{
  "get": [
    {
      "endpoint": "^/bank-accounts$",
      "response": {
        "status": 200,
        "body": {
          "content": [
            {
              "id": "3",
              "apiProduct": "ISABEL",
              "financialInstitutionId": "bnp",
              "financialInstitutionName": "BNP Paribas Fortis",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "label": "Aloic Abrim's security account",
              "iban": "BE93561683715667",
              "balance": 0,
              "currency": "EUR",
              "synchronizedAt": "2024-03-01T05:00:00",
              "status": "ACTIVE",
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "6",
              "financialInstitutionName": "BNP Paribas Fortis",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "label": "Doulehan Dracovich's office bank account",
              "iban": "BE81343377238700",
              "balance": -12001.93,
              "currency": "EUR",
              "status": "NOT_FOUND_IN_ISABEL",
              "client": {
                "id": "4",
                "firstName": "Doulehan",
                "lastName": "Dracovich",
                "municipality": null,
                "type": "BUDGET_GUIDANCE",
                "types": [
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "8",
              "financialInstitutionName": "BNP Paribas Fortis",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "label": "Eloise Elenthal's office bank account",
              "iban": "BE81343377238700",
              "balance": -101.93,
              "currency": "EUR",
              "status": "AUTH_INVALID",
              "expiresAt": "2024-01-01",
              "client": {
                "id": "5",
                "firstName": "Eloise",
                "lastName": "Elenthal",
                "municipality": null,
                "type": "RENT",
                "types": [
                  "RENT"
                ]
              }
            },
            {
              "id": "10",
              "financialInstitutionName": "Beobank",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/beobank.svg",
              "label": "Häelghor Häelghor's local bank account",
              "iban": "BE13679194762770",
              "balance": 1589.12,
              "currency": "EUR",
              "client": {
                "id": "8",
                "firstName": "Häelghor",
                "lastName": "Häelghor",
                "type": "PCSW",
                "types": [
                  "PCSW",
                  "RENT"
                ]
              }
            },
            {
              "id": "11",
              "financialInstitutionName": "Beobank",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/beobank.svg",
              "label": "Kantoorrekening",
              "iban": "BE13679194762770",
              "currency": "EUR"
            }
          ],
          "totalElements": 5,
          "size": 20,
          "number": 0
        }
      }
    },
    {
      "endpoint": "^/bank-accounts/1$",
      "response": {
        "status": 200,
        "body": {
          "id": "1",
          "type": "BASE",
          "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
          "label": "Aloic Abrim's base account",
          "iban": "BE41561146766410",
          "currentBalance": -458.96,
          "availableBalance": -458.96,
          "currency": "EUR",
          "synchronizedAt": "2024-03-08T05:00:00",
          "status": "ACTIVE",
          "supportPayments": true,
          "clientSettings": {
            "client": {
              "id": "1",
              "firstName": "Aloic",
              "lastName": "Abrim",
              "municipality": "Aarschot",
              "type": "DEBT_MEDIATION",
              "types": [
                "DEBT_MEDIATION",
                "FINANCIAL_MANAGEMENT",
                "BUDGET_GUIDANCE"
              ]
            },
            "type": "BASE",
            "ownerType": "CLIENT",
            "showIncomingTransactions": null,
            "showOutgoingTransactions": null,
            "showBalance": null,
            "balanceShared": true,
            "transactionsShared": true
          }
        }
      }
    },
    {
      "endpoint": "^/bank-accounts/6$",
      "response": {
        "status": 200,
        "body": {
          "id": "6",
          "financialInstitutionName": "BNP Paribas Fortis",
          "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
          "label": "Doulehan Dracovich's office bank account",
          "iban": "BE81343377238700",
          "status": "NOT_FOUND_IN_ISABEL",
          "currentBalance": -12001.93,
          "availableBalance": -12001.93,
          "currency": "EUR",
          "synchronizedAt": "2024-03-08T05:00:00",
          "supportPayments": false,
          "clientSettings": {
            "client": {
              "id": "4",
              "firstName": "Doulehan",
              "lastName": "Dracovich",
              "municipality": null,
              "type": "BUDGET_GUIDANCE",
              "types": [
                "BUDGET_GUIDANCE"
              ]
            },
            "type": "BASE",
            "ownerType": "OFFICE",
            "showIncomingTransactions": true,
            "showOutgoingTransactions": true,
            "showBalance": true,
            "balanceShared": null,
            "transactionsShared": null
          }
        }
      }
    },
    {
      "endpoint": "^/bank-accounts/8$",
      "response": {
        "status": 200,
        "body": {
          "id": "8",
          "financialInstitutionName": "BNP Paribas Fortis",
          "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
          "label": "Eloise Elenthal's office bank account",
          "iban": "BE81343377238700",
          "currentBalance": -101.93,
          "availableBalance": 50.07,
          "currency": "EUR",
          "status": "AUTH_INVALID",
          "expiresAt": "2024-01-01",
          "synchronizedAt": "2024-03-08T05:00:00",
          "supportPayments": false,
          "clientSettings": {
            "client": {
              "id": "5",
              "firstName": "Eloise",
              "lastName": "Elenthal",
              "municipality": null,
              "type": "RENT",
              "types": [
                "RENT"
              ]
            },
            "type": "BASE",
            "ownerType": "OFFICE",
            "showIncomingTransactions": true,
            "showOutgoingTransactions": true,
            "showBalance": true,
            "balanceShared": null,
            "transactionsShared": null
          }
        }
      }
    },
    {
      "endpoint": "^/bank-accounts/11$",
      "response": {
        "status": 200,
        "body": {
          "id": "11",
          "financialInstitutionName": "Beobank",
          "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/beobank.svg",
          "label": "Kantoorrekening",
          "iban": "BE13679194762770",
          "currency": "EUR",
          "status": "ACTIVE",
          "supportPayments": false,
          "clientSettings": null
        }
      }
    },
    {
      "endpoint": "^/bank-accounts/[^/]+$",
      "response": {
        "status": 200,
        "body": {
          "id": "3",
          "apiProduct": "ISABEL",
          "financialInstitutionId": "europabank",
          "financialInstitutionName": "Europabank",
          "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/europabank.svg",
          "label": "Aloic Abrim's security account",
          "iban": "BE93561683715667",
          "currentBalance": 0,
          "availableBalance": 125.12,
          "currency": "EUR",
          "synchronizedAt": "2024-03-01T05:00:00",
          "status": "ACTIVE",
          "supportPayments": true,
          "clientSettings": {
            "client": {
              "id": "1",
              "firstName": "Aloic",
              "lastName": "Abrim",
              "municipality": "Aarschot",
              "type": "DEBT_MEDIATION",
              "types": [
                "DEBT_MEDIATION",
                "FINANCIAL_MANAGEMENT",
                "BUDGET_GUIDANCE"
              ]
            },
            "type": "BASE",
            "ownerType": "OFFICE",
            "showIncomingTransactions": true,
            "showOutgoingTransactions": true,
            "showBalance": false,
            "balanceShared": null,
            "transactionsShared": null
          }
        }
      }
    },
    {
      "endpoint": "^/bank-accounts-to-link",
      "response": {
        "status": 200,
        "body": [
          {
            "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
            "financialInstitutionName": "BNP Parisbas",
            "label": "BNP account",
            "iban": "BE37436825748228"
          },
          {
            "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
            "financialInstitutionName": "BNP Parisbas",
            "label": "other BNP account",
            "iban": "BE57812841379535"
          },
          {
            "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/belfius.svg",
            "financialInstitutionName": "Belfius",
            "label": "Belfius account",
            "iban": "BE93233523975967"
          },
          {
            "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/ing.svg",
            "financialInstitutionName": "ING",
            "label": "ING account",
            "iban": "BE14954722595683"
          }
        ]
      }
    },
    {
      "endpoint": "^/clients$",
      "response": {
        "status": 200,
        "body": {
          "content": [
            {
              "id": "1",
              "firstName": "Aloic",
              "lastName": "Abrim",
              "municipality": "Aarschot",
              "type": "DEBT_MEDIATION",
              "types": [
                "DEBT_MEDIATION",
                "FINANCIAL_MANAGEMENT",
                "BUDGET_GUIDANCE"
              ],
              "lastNotificationDate": "2023-11-14T22:01:03Z",
              "numberOfNotifications": 1,
              "bankAccounts": [
                {
                  "id": "1",
                  "ownerType": "CLIENT",
                  "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
                  "label": "Aloic Abrim's bank account",
                  "iban": "BE41561146766410",
                  "expiring": false,
                  "balance": 458.96,
                  "currency": "EUR"
                }
              ]
            },
            {
              "id": "2",
              "firstName": "Bernard",
              "lastName": "Bodoucx",
              "municipality": "Brugge",
              "type": "FINANCIAL_MANAGEMENT",
              "types": [
                "FINANCIAL_MANAGEMENT"
              ],
              "lastNotificationDate": "2023-05-02T12:10:37Z",
              "numberOfNotifications": 4,
              "bankAccounts": [
                {
                  "ownerType": "CLIENT",
                  "logoUrl": null,
                  "label": "Bernard Boudoucx's private bank account",
                  "iban": "BE86519834538350",
                  "expiring": false,
                  "balance": null,
                  "currency": null
                }
              ]
            },
            {
              "id": "3",
              "firstName": "Cedric",
              "lastName": "Crudelac",
              "municipality": "Cardif",
              "type": "SOCIAL_RENT",
              "types": [
                "SOCIAL_RENT"
              ],
              "lastNotificationDate": null,
              "numberOfNotifications": 0,
              "bankAccounts": [
                {
                  "id": "5",
                  "ownerType": "CLIENT",
                  "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/abn_amro.svg",
                  "label": "Cedric Crudelac's bank account",
                  "iban": "BE60817979793170",
                  "expiring": false,
                  "balance": 8912.95,
                  "currency": "GBP"
                }
              ]
            },
            {
              "id": "4",
              "firstName": "Doulehan",
              "lastName": "Dracovich",
              "municipality": null,
              "type": "BUDGET_GUIDANCE",
              "types": [
                "BUDGET_GUIDANCE"
              ],
              "lastNotificationDate": "2023-11-16T11:35:49Z",
              "numberOfNotifications": 3,
              "bankAccounts": [
                {
                  "id": "6",
                  "ownerType": "OFFICE",
                  "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
                  "label": "Doulehan Dracovich's office bank account",
                  "iban": "BE81343377238700",
                  "expiring": true,
                  "balance": -12001.93,
                  "currency": "EUR"
                },
                {
                  "id": "7",
                  "ownerType": "CLIENT",
                  "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/abn_amro.svg",
                  "label": "Doulehan Dracovich's private bank account",
                  "iban": "BE29949152758898",
                  "expiring": false,
                  "balance": 43.98,
                  "currency": "EUR"
                }
              ]
            },
            {
              "id": "5",
              "firstName": "Eloise",
              "lastName": "Elenthal",
              "municipality": null,
              "type": "RENT",
              "types": [
                "RENT"
              ],
              "lastNotificationDate": "2023-11-15T12:01:03Z",
              "numberOfNotifications": 0,
              "bankAccounts": [
                {
                  "id": "8",
                  "ownerType": "OFFICE",
                  "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
                  "label": "Eloise Elenthal's office bank account",
                  "iban": "BE81343377238700",
                  "expiring": false,
                  "balance": -101.93,
                  "currency": "EUR"
                },
                {
                  "ownerType": "CLIENT",
                  "label": "Eloise Elenthal's private primary bank account",
                  "iban": "BE29949152758898"
                },
                {
                  "ownerType": "CLIENT",
                  "label": "Eloise Elenthal's private secondary bank account",
                  "iban": "BE29646815321654"
                }
              ]
            },
            {
              "id": "6",
              "firstName": "Fainor",
              "lastName": "Falenthir",
              "municipality": "",
              "type": "PCSW",
              "types": [
                "PCSW"
              ],
              "numberOfNotifications": 0,
              "bankAccounts": []
            },
            {
              "id": "7",
              "firstName": "Gregory",
              "lastName": "Grohe",
              "municipality": "Gent",
              "type": "RENT",
              "types": [
                "RENT"
              ],
              "lastNotificationDate": "2023-11-15T12:01:03Z",
              "numberOfNotifications": 0,
              "bankAccounts": [
                {
                  "ownerType": "CLIENT",
                  "label": "Gregory Grohe's bpost bank account",
                  "iban": "BE53146194750684"
                },
                {
                  "ownerType": "CLIENT",
                  "label": "Gregory Grohe's fintro bank account",
                  "iban": "BE58940856172030"
                },
                {
                  "id": "9",
                  "ownerType": "CLIENT",
                  "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/vdk.svg",
                  "label": "Gregory Grohe's vdk bank account",
                  "iban": "BE73343310900544",
                  "expiring": false,
                  "balance": 60.33,
                  "currency": "EUR"
                }
              ]
            },
            {
              "id": "8",
              "firstName": "Häelghor",
              "lastName": "Häelghor",
              "type": "PCSW",
              "types": [
                "PCSW",
                "RENT"
              ],
              "numberOfNotifications": 0,
              "bankAccounts": [
                {
                  "id": "10",
                  "ownerType": "OFFICE",
                  "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/beobank.svg",
                  "label": "Häelghor Häelghor's local bank account",
                  "iban": "BE13679194762770",
                  "expiring": true,
                  "balance": 1589.12,
                  "currency": "EUR"
                },
                {
                  "ownerType": "CLIENT",
                  "label": "Häelghor Häelghor's offshore bank account",
                  "iban": "BE65817171184396",
                  "position": 1
                }
              ]
            },
            {
              "id": "9",
              "firstName": "Ilya",
              "lastName": "Incoreva",
              "municipality": "Izegem",
              "type": "DEBT_MEDIATION",
              "types": [
                "DEBT_MEDIATION"
              ],
              "lastNotificationDate": null,
              "numberOfNotifications": 0,
              "bankAccounts": []
            },
            {
              "id": "10",
              "firstName": "Jelena",
              "lastName": "Jacorolich",
              "municipality": "",
              "type": "DEBT_MEDIATION",
              "types": [
                "DEBT_MEDIATION"
              ],
              "lastNotificationDate": null,
              "numberOfNotifications": 0,
              "bankAccounts": []
            },
            {
              "id": "11",
              "firstName": "Khalid",
              "lastName": "Kumar",
              "municipality": null,
              "type": "PCSW",
              "types": [
                "PCSW"
              ],
              "lastNotificationDate": null,
              "numberOfNotifications": 0,
              "bankAccounts": []
            },
            {
              "id": "12",
              "firstName": "Lemur",
              "lastName": "Lovondich",
              "municipality": "",
              "type": "RENT",
              "types": [
                "RENT"
              ],
              "lastNotificationDate": null,
              "numberOfNotifications": 0,
              "bankAccounts": []
            },
            {
              "id": "13",
              "firstName": "Mehral",
              "lastName": "Mundil",
              "municipality": "",
              "type": "BUDGET_GUIDANCE",
              "types": [
                "BUDGET_GUIDANCE"
              ],
              "lastNotificationDate": null,
              "numberOfNotifications": 0,
              "bankAccounts": []
            },
            {
              "id": "14",
              "firstName": "Nidar",
              "lastName": "Nuluccu",
              "municipality": "",
              "type": "FINANCIAL_MANAGEMENT",
              "types": [
                "FINANCIAL_MANAGEMENT"
              ],
              "lastNotificationDate": null,
              "numberOfNotifications": 0,
              "bankAccounts": []
            },
            {
              "id": "15",
              "firstName": "Orphe",
              "lastName": "Oolo",
              "municipality": "",
              "type": "RENT",
              "types": [
                "RENT"
              ],
              "lastNotificationDate": null,
              "numberOfNotifications": 0,
              "bankAccounts": []
            },
            {
              "id": "16",
              "firstName": "Pendar",
              "lastName": "Pudalic",
              "municipality": "",
              "type": "FINANCIAL_MANAGEMENT",
              "types": [
                "FINANCIAL_MANAGEMENT"
              ],
              "lastNotificationDate": null,
              "numberOfNotifications": 0,
              "bankAccounts": []
            }
          ],
          "totalElements": 268,
          "size": 25,
          "number": 6
        }
      }
    },
    {
      "endpoint": "^/clients/9$",
      "response": {
        "status": 200,
        "body": {
          "id": "9",
          "firstName": "Ilya",
          "lastName": "Incoreva",
          "email": "a.a@example.com",
          "municipality": "Izegem",
          "type": "DEBT_MEDIATION",
          "types": [
            "DEBT_MEDIATION"
          ],
          "bankAccounts": []
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+$",
      "response": {
        "status": 200,
        "body": {
          "id": "1",
          "firstName": "Aloic",
          "lastName": "Abrim",
          "email": "a.a@example.com",
          "municipality": "Aarschot",
          "type": "DEBT_MEDIATION",
          "types": [
            "DEBT_MEDIATION",
            "FINANCIAL_MANAGEMENT",
            "BUDGET_GUIDANCE"
          ],
          "lastNotificationDate": "2023-11-14T22:01:03Z",
          "numberOfNotifications": 1,
          "bankAccounts": [
            {
              "id": "1",
              "ownerType": "OFFICE",
              "type": "BASE",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "label": "Aloic Abrim's base account",
              "iban": "BE41561146766410",
              "expiring": false,
              "balance": -458.96,
              "currency": "EUR",
              "supportPayments": true
            },
            {
              "id": "2",
              "ownerType": "OFFICE",
              "type": "RESERVE",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "label": "Aloic Abrim's reserve account",
              "iban": "BE75456473837751",
              "expiring": false,
              "balance": 1682.98,
              "currency": "EUR",
              "supportPayments": true
            },
            {
              "id": "3",
              "ownerType": "OFFICE",
              "type": "SECURITY",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "label": "Aloic Abrim's security account",
              "iban": "BE93561683715667",
              "expiring": false,
              "balance": 0,
              "currency": "EUR",
              "supportPayments": false
            },
            {
              "id": "4",
              "ownerType": "OFFICE",
              "type": "SAVINGS",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "label": "Aloic Abrim's savings account",
              "iban": "BE45735629549889",
              "expiring": false,
              "balance": 1885.26,
              "currency": "EUR",
              "supportPayments": false
            },
            {
              "id": "5",
              "ownerType": "OFFICE",
              "type": "VAPH",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "label": "Aloic Abrim's VAPH account",
              "iban": "BE95988969723558",
              "expiring": false,
              "balance": 94.68,
              "supportPayments": false
            },
            {
              "ownerType": "OFFICE",
              "type": "ALLOWANCE",
              "iban": "BE48735214218727",
              "expiring": false
            },
            {
              "id": "6",
              "ownerType": "CLIENT",
              "type": "BASE",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "label": "Aloic Abrim's client account 1",
              "iban": "BE4279861552112",
              "expiring": false,
              "balance": 58.96,
              "currency": "EUR",
              "supportPayments": false
            },
            {
              "id": "7",
              "ownerType": "CLIENT",
              "type": "BASE",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "label": "Aloic Abrim's client account 2",
              "iban": "BE22798323225847",
              "expiring": false,
              "balance": 85.69,
              "currency": "EUR",
              "supportPayments": false
            }
          ]
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/bank-accounts$",
      "response": {
        "status": 200,
        "body": {
          "officeAccounts": [
            {
              "position": 1,
              "type": "ALLOWANCE",
              "iban": "BE48735214218727",
              "linked": false
            },
            {
              "position": 2,
              "type": "SECURITY",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "financialInstitutionName": "BNP Parisbas",
              "label": "Aloic Abrim's security account",
              "iban": "BE93561683715667",
              "linked": true
            }
          ],
          "clientAccounts": [
            {
              "position": 1,
              "type": "BASE",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "financialInstitutionName": "BNP Parisbas",
              "label": "Aloic Abrim's base account",
              "iban": "BE41561146766410",
              "linked": true
            },
            {
              "position": 2,
              "type": "RESERVE",
              "label": "Aloic Abrim's reserve account",
              "iban": "BE75456473837751",
              "linked": false
            },
            {
              "position": 3,
              "type": "SAVINGS",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "financialInstitutionName": "BNP Parisbas",
              "label": "Aloic Abrim's savings account",
              "iban": "BE45735629549889",
              "linked": true
            },
            {
              "position": 4,
              "type": "VAPH",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "financialInstitutionName": "BNP Parisbas",
              "label": "Aloic Abrim's VAPH account",
              "iban": "BE95988969723558"
            }
          ]
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/beneficiaries$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": null,
            "global": false,
            "counterpartName": "Basisrekening",
            "counterpartReference": "BE35978191265737",
            "type": "BANK_ACCOUNT"
          },
          {
            "id": "9f7fd32f-55db-4660-a01f-87b4574846d9",
            "global": false,
            "counterpartName": "KSA",
            "counterpartReference": "BE16812136232274",
            "type": "BENEFICIARY"
          },
          {
            "id": null,
            "global": false,
            "counterpartName": "NMBS",
            "counterpartReference": "BE91735414567476",
            "type": "CREDITOR"
          }
        ]
      }
    },
    {
      "endpoint": "^/clients/[^/]+/creditor-payment-info-report$",
      "response": {
        "status": 200,
        "body": []
      }
    },
    {
      "endpoint": "^/clients/[^/]+/creditor-payment-info$",
      "response": {
        "status": 200,
        "body": {
          "paymentDates": [
            "2021-02-26",
            "2021-05-26",
            "2021-08-26",
            "2021-11-26",
            "2022-02-26",
            "2022-05-26",
            "2022-08-26",
            "2022-11-26",
            "2023-02-26",
            "2023-05-26",
            "2023-08-26"
          ],
          "creditorPaymentInfo": [
            {
              "position": 1,
              "name": "test strucured",
              "retainedAmount": 5000,
              "distribution": 11.11,
              "remainingDebt": 3896.92,
              "paymentByThirdParties": 0,
              "payments": {
                "2021-02-26": 100.28,
                "2021-05-26": 100.28,
                "2021-08-26": 100.28,
                "2021-11-26": 100.28,
                "2022-02-26": 100.28,
                "2022-05-26": 100.28,
                "2022-08-26": 100.28,
                "2022-11-26": 100.28,
                "2023-02-26": 100.28,
                "2023-05-26": 100.28,
                "2023-08-26": 100.28
              }
            },
            {
              "position": 2,
              "name": "NMBS",
              "retainedAmount": 10123,
              "distribution": 22.23,
              "remainingDebt": 6330.88,
              "paymentByThirdParties": 2000,
              "payments": {
                "2021-02-26": 162.92,
                "2021-05-26": 162.92,
                "2021-08-26": 162.92,
                "2021-11-26": 162.92,
                "2022-02-26": 162.92,
                "2022-05-26": 162.92,
                "2022-08-26": 162.92,
                "2022-11-26": 162.92,
                "2023-02-26": 162.92,
                "2023-05-26": 162.92,
                "2023-08-26": 162.92
              }
            },
            {
              "position": 3,
              "name": "NMBS anders",
              "retainedAmount": 15000,
              "distribution": 33.33,
              "remainingDebt": 11690.76,
              "paymentByThirdParties": 0,
              "payments": {
                "2021-02-26": 300.84,
                "2021-05-26": 300.84,
                "2021-08-26": 300.84,
                "2021-11-26": 300.84,
                "2022-02-26": 300.84,
                "2022-05-26": 300.84,
                "2022-08-26": 300.84,
                "2022-11-26": 300.84,
                "2023-02-26": 300.84,
                "2023-05-26": 300.84,
                "2023-08-26": 300.84
              }
            },
            {
              "position": 4,
              "name": "Proximus",
              "retainedAmount": 15000.21,
              "distribution": 33.33,
              "remainingDebt": 10911.41,
              "paymentByThirdParties": 1000,
              "payments": {
                "2021-02-26": 280.80,
                "2021-05-26": 280.80,
                "2021-08-26": 280.80,
                "2021-11-26": 280.80,
                "2022-02-26": 280.80,
                "2022-05-26": 280.80,
                "2022-08-26": 280.80,
                "2022-11-26": 280.80,
                "2023-02-26": 280.80,
                "2023-05-26": 280.80,
                "2023-08-26": 280.80
              }
            }
          ],
          "total": {
            "retainedAmount": 49020.13,
            "remainingDebt": 36726.89,
            "paymentByThirdParties": 3000,
            "payments": {
              "2021-02-26": 844.84,
              "2021-05-26": 844.84,
              "2021-08-26": 844.84,
              "2021-11-26": 844.84,
              "2022-02-26": 844.84,
              "2022-05-26": 844.84,
              "2022-08-26": 844.84,
              "2022-11-26": 844.84,
              "2023-02-26": 844.84,
              "2023-05-26": 844.84,
              "2023-08-26": 844.84
            }
          }
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/creditor-payments$",
      "response": {
        "status": 200,
        "body": {
          "totalAmount": 1000,
          "payments": [
            {
              "position": 1,
              "name": "Creditor #1",
              "counterpartName": "Creditor 1",
              "iban": "BE82663642898968",
              "remittanceInformation": "987654321009",
              "remittanceInformationType": "STRUCTURED",
              "remainingDebt": 500
            },
            {
              "position": 2,
              "name": "Creditor #2",
              "counterpartName": "Creditor 2",
              "iban": "BE80436722874977",
              "remittanceInformation": "Message",
              "remittanceInformationType": "UNSTRUCTURED",
              "remainingDebt": 300
            },
            {
              "position": 1,
              "name": "Creditor #1",
              "counterpartName": "Creditor 1"
            }
          ]
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/creditor-report$",
      "response": {
        "status": 200,
        "body": []
      }
    },
    {
      "endpoint": "^/clients/9/creditors$",
      "response": {
        "status": 200,
        "body": []
      }
    },
    {
      "endpoint": "^/clients/[^/]+/creditors$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": "03f82c89-90a2-4782-aed5-fc4f3f30078a",
            "position": 1,
            "name": "test structured #1",
            "counterpartName": "test structured 1",
            "address": null,
            "companyNumber": null,
            "iban": "",
            "remittanceInformation": "102933653179",
            "remittanceInformationType": "STRUCTURED",
            "paymentByThirdParties": 0,
            "retainedAmount": 5000,
            "periodicAmountToPay": 100.28,
            "mainSum": null,
            "totalDebt": null,
            "interest": null,
            "costs": null,
            "courtCosts": null,
            "increases": null
          },
          {
            "id": "d969f630-be27-456b-885d-55d03e23a1fe",
            "position": 2,
            "name": "NMBS",
            "counterpartName": "NMBS",
            "address": "adres nmbs",
            "companyNumber": "0203.430.576",
            "iban": "BE91735414567476",
            "remittanceInformation": "debt",
            "remittanceInformationType": "UNSTRUCTURED",
            "paymentByThirdParties": 2000,
            "retainedAmount": 10123,
            "periodicAmountToPay": 162.92,
            "mainSum": 5000,
            "totalDebt": 0.12,
            "interest": 100.1,
            "costs": 12.1,
            "courtCosts": 100,
            "increases": 25
          },
          {
            "id": "0026051c-46f6-4e5f-848e-675fa02a643d",
            "position": 3,
            "name": "NMBS anders",
            "counterpartName": "NMBS anders",
            "address": null,
            "companyNumber": "0203.430.576",
            "iban": "BE91735414567476",
            "remittanceInformation": "andere schuld",
            "remittanceInformationType": "UNSTRUCTURED",
            "paymentByThirdParties": 0,
            "retainedAmount": 15000,
            "periodicAmountToPay": 300.84,
            "mainSum": 25000,
            "totalDebt": 30000,
            "interest": null,
            "costs": null,
            "courtCosts": 300,
            "increases": 75
          },
          {
            "id": "1ef03f61-a380-4563-9ed6-134a70abd424",
            "position": 4,
            "name": "Proximus",
            "counterpartName": "Proximus",
            "address": "straat 1\n1234 gemeente",
            "companyNumber": "0202.239.951",
            "iban": "BE02663366543140",
            "remittanceInformation": null,
            "remittanceInformationType": null,
            "paymentByThirdParties": 1000,
            "retainedAmount": 15000.21,
            "periodicAmountToPay": 280.8,
            "mainSum": 10000,
            "totalDebt": 10000,
            "interest": 121,
            "costs": 1,
            "courtCosts": 100,
            "increases": 25
          }
        ]
      }
    },
    {
      "endpoint": "^/clients/9/dossier-info/[^/]+$",
      "response": {
        "status": 200,
        "body": {
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/dossier-info/[^/]+$",
      "response": {
        "status": 200,
        "body": {
          "startDate": "2020-01-01",
          "endDate": "2027-12-31",
          "admissibilityDateSettlement": "2019-12-01",
          "homologationDateSettlement": "2019-12-15",
          "caseIdentifier": "14752",
          "docketNumber": "RN. 125",
          "labourCourt": {
            "id": "ec65f51f-7f61-48ca-805f-86a26cccdcac",
            "name": "Arbeidsrechtbank Antwerpen",
            "department": "afdeling Hasselt"
          },
          "totalDebt": 50000,
          "mainSum": 40000,
          "interest": 4586.54,
          "costs": 1250,
          "courtCosts": 2000,
          "increases": 250,
          "retainedAmount": 45000,
          "settlementType": "PERCENTAGE",
          "settlementAmount": null,
          "settlementPercentage": 15.0,
          "monthlyPaymentsPeriodicity": 3,
          "paymentStartDate": "2021-02-26",
          "paymentEndDate": "2028-02-25",
          "balanceThreshold": 5000
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/general-info$",
      "response": {
        "status": 200,
        "body": {
          "firstName": "Aloic",
          "lastName": "Abrim",
          "address": {
            "street": "Kerkstraat",
            "number": "15",
            "postalCode": "3200",
            "city": "Aarschot"
          },
          "email": "abrim.aloic@gmail.com",
          "birthDate": "1996-07-23",
          "remarks": "Geen opmerkingen",
          "language": "nl"
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/notifications$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": "e7b590e4-b16c-4c8b-b473-dfeca82a4c8f",
            "bankAccount": {
              "id": "1",
              "type": "BASE",
              "ownerType": "OFFICE",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "label": "Aloic Abrim's base account",
              "iban": "BE41561146766410",
              "expiring": false,
              "status": "ACTIVE",
              "balance": 148.45,
              "currency": "EUR",
              "position": 1,
              "financialInstitutionName": "BNP Paribas Fortis",
              "supportPayments": false
            },
            "client": {
              "id": "1",
              "firstName": "Aloic",
              "lastName": "Abrim",
              "type": "DEBT_MEDIATION",
              "types": [
                "DEBT_MEDIATION"
              ],
              "municipality": "Aarschot"
            },
            "dateCreated": "2024-04-30",
            "closed": false,
            "closedBySystem": false,
            "title": "Nieuwe inkomsten gedetecteerd",
            "description": "Nieuwe inkomsten gedetecteerd: ± € 50,00 op 29/04/2024",
            "details": null,
            "subNotifications": [
              {
                "dateCreated": "2024-05-16",
                "description": "Manueel afgesloten door Jack De Ripper"
              },
              {
                "dateCreated": "2024-05-17",
                "description": "Manueel heropend door Jack De Ripper"
              }
            ],
            "document": null
          },
          {
            "id": "e9791555-e22d-4302-95b1-54d4fac87fa5",
            "bankAccount": {
              "id": "1",
              "type": "BASE",
              "ownerType": "OFFICE",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "label": "Aloic Abrim's base account",
              "iban": "BE41561146766410",
              "expiring": false,
              "status": "ACTIVE",
              "balance": 148.45,
              "currency": "EUR",
              "position": 1,
              "financialInstitutionName": "BNP Paribas Fortis",
              "supportPayments": false
            },
            "client": {
              "id": "1",
              "firstName": "Aloic",
              "lastName": "Abrim",
              "type": "DEBT_MEDIATION",
              "types": [
                "DEBT_MEDIATION"
              ],
              "municipality": "Aarschot"
            },
            "dateCreated": "2024-04-11",
            "closed": false,
            "closedBySystem": false,
            "title": "Verwachte betaling ontbreekt",
            "description": "Er werd een betaling van ± € -500,16 aan Woonpartners verwacht op 01/04/2024, maar deze werd niet gedetecteerd.",
            "details": "Details van de verwachte verrichting:<br>- Bedrag: ± € -500,16<br>- Datum: 01/04/2024<br>- Naam tegenpartij: Woonpartners<br>- Referentie tegenpartij: BE72 5495 9383 4216<br>- Mededeling: -<br>- Omschrijving: overschrijving",
            "document": null,
            "subNotifications": []
          },
          {
            "id": "4b219fd9-d245-4bd3-9012-f03f2ccd9fd6",
            "bankAccount": null,
            "client": {
              "id": "1",
              "firstName": "Aloic",
              "lastName": "Abrim",
              "type": "DEBT_MEDIATION",
              "types": [
                "DEBT_MEDIATION"
              ],
              "municipality": "Aarschot"
            },
            "dateCreated": "2023-06-29",
            "closed": false,
            "closedBySystem": false,
            "title": "Eindrapport moet ingediend worden",
            "description": "Tegen 29/07/2023 moet het eindverslag schuldbemiddeling ingediend worden bij Arbeidsrechtbank Gent.",
            "details": null,
            "subNotifications": [],
            "document": null
          },
          {
            "id": "373207a6-b1e6-4d97-9d20-b494c78f477d",
            "bankAccount": null,
            "client": {
              "id": "1",
              "firstName": "Aloic",
              "lastName": "Abrim",
              "type": "DEBT_MEDIATION",
              "types": [
                "DEBT_MEDIATION"
              ],
              "municipality": "Aarschot"
            },
            "dateCreated": "2023-04-14",
            "closed": false,
            "closedBySystem": false,
            "title": "Aanvraag om te betalen",
            "description": "Client heeft gevraagd om deze factuur te betalen",
            "details": null,
            "subNotifications": [],
            "document": {
              "id": "30688aa8-7f0f-47f9-a7b0-953f20bdae69",
              "name": "factuur.pdf",
              "shareResponse": null
            }
          }
        ]
      }
    },
    {
      "endpoint": "^/clients/[^/]+/referral-code-status$",
      "response": {
        "status": 200,
        "body": {
          "code": "ABCD123"
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/report-types$",
      "response": {
        "status": 200,
        "body": [
          {
            "type": "FINANCIAL_REPORT",
            "extension": "pdf",
            "disabled": false
          },
          {
            "type": "YEARLY_OVERSIGHT_REPORT",
            "extension": "pdf",
            "disabled": false
          },
          {
            "type": "YEARLY_DEBT_REPORT",
            "extension": "docx",
            "disabled": false
          },
          {
            "type": "FINAL_DEBT_REPORT",
            "extension": "docx",
            "disabled": false
          },
          {
            "type": "YEARLY_REPORT_XLSX_GUARDIANSHIP",
            "extension": "xlsx",
            "disabled": false
          }
        ]
      }
    },
    {
      "endpoint": "^/clients/[^/]+/report-types/FINAL_DEBT_REPORT/form-info$",
      "response": {
        "status": 200,
        "body": {
          "bankAccountSelection": "SINGLE",
          "officeAccountIds": [
            "1",
            "2"
          ],
          "clientAccountIds": [],
          "supportedPeriods": []
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/report-types/FINANCIAL_REPORT/form-info$",
      "response": {
        "status": 200,
        "body": {
          "bankAccountSelection": "MULTIPLE_SPLIT",
          "officeAccountIds": [
            "1",
            "2",
            "3",
            "4",
            "5"
          ],
          "clientAccountIds": [
            "6",
            "7"
          ],
          "supportedPeriods": [
            "MONTHLY",
            "QUARTERLY",
            "YEARLY"
          ],
          "defaultCustom": {
            "startDate": "2023-07-01",
            "endDate": "2024-06-30"
          },
          "defaultMonthly": {
            "startDate": "2024-06-01",
            "endDate": "2024-06-30"
          },
          "defaultQuarterly": {
            "startDate": "2024-04-01",
            "endDate": "2024-06-30"
          },
          "defaultYearly": {
            "startDate": "2023-01-01",
            "endDate": "2023-12-31"
          },
          "selectablePeriod": {
            "startDate": "2020-07-09",
            "endDate": "2024-07-08"
          }
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/report-types/YEARLY_DEBT_REPORT/form-info$",
      "response": {
        "status": 200,
        "body": {
          "bankAccountSelection": "SINGLE",
          "officeAccountIds": [
            "1",
            "2"
          ],
          "clientAccountIds": [],
          "supportedPeriods": [
            "CUSTOM"
          ],
          "defaultCustom": {
            "startDate": "2023-07-01",
            "endDate": "2024-06-30"
          },
          "selectablePeriod": {
            "startDate": "2020-07-09",
            "endDate": "2024-07-08"
          }
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/report-types/YEARLY_OVERSIGHT_REPORT/form-info$",
      "response": {
        "status": 200,
        "body": {
          "bankAccountSelection": "SINGLE_BULK",
          "officeAccountIds": [
            "1",
            "2",
            "3",
            "4",
            "5"
          ],
          "clientAccountIds": [
            "6",
            "7"
          ],
          "supportedPeriods": [
            "MONTHLY",
            "QUARTERLY",
            "YEARLY",
            "CUSTOM"
          ],
          "defaultCustom": {
            "startDate": "2023-07-01",
            "endDate": "2024-06-30"
          },
          "defaultMonthly": {
            "startDate": "2024-06-01",
            "endDate": "2024-06-30"
          },
          "defaultQuarterly": {
            "startDate": "2024-04-01",
            "endDate": "2024-06-30"
          },
          "defaultYearly": {
            "startDate": "2023-01-01",
            "endDate": "2023-12-31"
          },
          "selectablePeriod": {
            "startDate": "2020-07-09",
            "endDate": "2024-07-08"
          }
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/report-types/YEARLY_REPORT_XLSX_GUARDIANSHIP/form-info$",
      "response": {
        "status": 200,
        "body": {
          "bankAccountSelection": "NONE",
          "officeAccountIds": [],
          "clientAccountIds": [],
          "supportedPeriods": [
            "CUSTOM"
          ],
          "defaultCustom": {
            "startDate": "2023-07-01",
            "endDate": "2024-06-30"
          },
          "selectablePeriod": {
            "startDate": "2020-07-09",
            "endDate": "2024-07-08"
          }
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/transaction-tags$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": "1",
            "name": "Trein"
          },
          {
            "id": "1",
            "name": "Geschenken"
          },
          {
            "id": "1",
            "name": "Kinderen"
          }
        ]
      }
    },
    {
      "endpoint": "^/clients-by-iban$",
      "response": {
        "status": 200,
        "body": []
      }
    },
    {
      "endpoint": "^/clients-to-link$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": "1",
            "firstName": "Aloic",
            "lastName": "Abrim",
            "municipality": "Aarschot",
            "type": "DEBT_MEDIATION",
            "types": [
              "DEBT_MEDIATION",
              "FINANCIAL_MANAGEMENT",
              "BUDGET_GUIDANCE"
            ]
          },
          {
            "id": "2",
            "firstName": "Bernard",
            "lastName": "Bodoucx",
            "municipality": "Brugge",
            "type": "FINANCIAL_MANAGEMENT",
            "types": [
              "FINANCIAL_MANAGEMENT"
            ]
          },
          {
            "id": "9",
            "firstName": "Ilya",
            "lastName": "Incoreva",
            "municipality": "Izegem",
            "type": "DEBT_MEDIATION",
            "types": [
              "DEBT_MEDIATION"
            ]
          },
          {
            "id": "10",
            "firstName": "Jelena",
            "lastName": "Jacorolich",
            "municipality": "",
            "type": "DEBT_MEDIATION",
            "types": [
              "DEBT_MEDIATION"
            ]
          },
          {
            "id": "14",
            "firstName": "Nidar",
            "lastName": "Nuluccu",
            "municipality": "",
            "type": "FINANCIAL_MANAGEMENT",
            "types": [
              "FINANCIAL_MANAGEMENT"
            ]
          },
          {
            "id": "16",
            "firstName": "Pendar",
            "lastName": "Pudalic",
            "municipality": "",
            "type": "FINANCIAL_MANAGEMENT",
            "types": [
              "FINANCIAL_MANAGEMENT"
            ]
          }
        ]
      }
    },
    {
      "endpoint": "^/client-types/[^/]+/bank-account-types$",
      "response": {
        "status": 200,
        "body": [
          "BASE",
          "RESERVE",
          "SAVINGS",
          "ALLOWANCE",
          "SECURITY",
          "VAPH"
        ]
      }
    },
    {
      "endpoint": "^/courts$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": "01a03a58-60c7-4648-b093-58744eedc391",
            "name": "Arbeidsrechtbank Antwerpen",
            "department": null
          },
          {
            "id": "7aaeaede-a686-4aad-ad19-6a4690594039",
            "name": "Arbeidsrechtbank Antwerpen",
            "department": "afdeling Antwerpen"
          },
          {
            "id": "ec65f51f-7f61-48ca-805f-86a26cccdcac",
            "name": "Arbeidsrechtbank Antwerpen",
            "department": "afdeling Hasselt"
          },
          {
            "id": "3f4acf1a-5827-4eb4-b4d1-e357d7bbefbd",
            "name": "Arbeidsrechtbank Antwerpen",
            "department": "afdeling Mechelen"
          },
          {
            "id": "3a1010ab-7a6f-4e37-9e3a-42a17df6ea00",
            "name": "Arbeidsrechtbank Antwerpen",
            "department": "afdeling Tongeren"
          },
          {
            "id": "6c9101d0-1e4d-4608-9641-8f9be144b35e",
            "name": "Arbeidsrechtbank Antwerpen",
            "department": "afdeling Turnhout"
          },
          {
            "id": "a8abda58-cff3-472d-a02d-4fbce48e28fc",
            "name": "Arbeidsrechtbank Gent",
            "department": null
          },
          {
            "id": "83d46c66-5a52-4efb-815a-60cabc93620a",
            "name": "Arbeidsrechtbank Gent",
            "department": "afdeling Aalst"
          },
          {
            "id": "913013d7-98db-407c-9c84-677644a73d0a",
            "name": "Arbeidsrechtbank Gent",
            "department": "afdeling Brugge"
          },
          {
            "id": "d9c8831a-7601-41a3-b9de-04a1cb94f523",
            "name": "Arbeidsrechtbank Gent",
            "department": "afdeling Dendermonde"
          },
          {
            "id": "b11ba668-fef8-40b5-a9ed-158536500273",
            "name": "Arbeidsrechtbank Gent",
            "department": "afdeling Gent"
          },
          {
            "id": "2c34d546-e367-409f-90cc-2601ad3f963a",
            "name": "Arbeidsrechtbank Gent",
            "department": "afdeling Ieper"
          },
          {
            "id": "35d44acd-b547-48ac-832b-b11cd31a5609",
            "name": "Arbeidsrechtbank Gent",
            "department": "afdeling Kortrijk"
          },
          {
            "id": "fc6dbc66-9570-4a06-95fc-f96e90fedc25",
            "name": "Arbeidsrechtbank Gent",
            "department": "afdeling Oudenaarde"
          },
          {
            "id": "fa83acf8-cd6c-48d3-93ea-0665d5eb76d1",
            "name": "Arbeidsrechtbank Gent",
            "department": "afdeling Roeselare"
          },
          {
            "id": "16e0b72b-aa98-42ee-9e75-d8ec42b0426c",
            "name": "Arbeidsrechtbank Gent",
            "department": "afdeling Sint-Niklaas"
          },
          {
            "id": "fcb6953f-b7c9-4a89-b95e-0e3fbe555add",
            "name": "Arbeidsrechtbank Gent",
            "department": "afdeling Veurne"
          },
          {
            "id": "25e83a6c-5f9f-4e8e-94e9-e2fb508afeb3",
            "name": "Arbeidsrechtbank Leuven",
            "department": null
          },
          {
            "id": "d75e658c-7725-4f34-a4e9-034697871fd6",
            "name": "Nederlandstalige Arbeidsrechtbank Brussel",
            "department": null
          },
          {
            "id": "057b43d1-5f60-4d24-8d6f-556dc29b457a",
            "name": "Tribunal du travail d'Eupen",
            "department": null
          },
          {
            "id": "86fd7ae6-6dac-4d82-843b-8fd942f12a47",
            "name": "Tribunal du travail de Liège",
            "department": null
          },
          {
            "id": "53385309-c60b-4b81-94a6-f25f73893098",
            "name": "Tribunal du travail de Liège",
            "department": "division Arlon"
          },
          {
            "id": "5ebbe233-902e-46b6-98e4-fe26715ce8bb",
            "name": "Tribunal du travail de Liège",
            "department": "division Dinant"
          },
          {
            "id": "7289f468-02a4-4f5b-bcff-9e771262fc3f",
            "name": "Tribunal du travail de Liège",
            "department": "division Huy"
          },
          {
            "id": "7ec96885-2b6a-45ae-9139-b45ab8cf913c",
            "name": "Tribunal du travail de Liège",
            "department": "division Liège"
          },
          {
            "id": "79da5390-60a3-4784-975c-2fb6548d5c83",
            "name": "Tribunal du travail de Liège",
            "department": "division Marche-en-Famenne"
          },
          {
            "id": "9b94e370-d381-495d-b500-109a02499a4c",
            "name": "Tribunal du travail de Liège",
            "department": "division Namur"
          },
          {
            "id": "4e186013-f4a3-4e95-8099-e42328a4e19a",
            "name": "Tribunal du travail de Liège",
            "department": "division Neufchâteau"
          },
          {
            "id": "e095d1d9-29a2-4d47-bbe4-45010ff1c2df",
            "name": "Tribunal du travail de Liège",
            "department": "division Verviers"
          },
          {
            "id": "c36ae8a0-6f97-4524-a5a7-c84e5c0a77c3",
            "name": "Tribunal du travail du Brabant Wallon",
            "department": null
          },
          {
            "id": "d9268a08-60b0-4255-a2c0-05e485d1acac",
            "name": "Tribunal du travail du Brabant Wallon",
            "department": "division Nivelles"
          },
          {
            "id": "df349a47-0959-4055-b5a4-065393e59f84",
            "name": "Tribunal du travail du Brabant Wallon",
            "department": "division Wavre"
          },
          {
            "id": "031e55e9-c9e5-47ec-bb29-e38ad11e8eb7",
            "name": "Tribunal du travail du Hainaut",
            "department": null
          },
          {
            "id": "85e5952b-d298-4725-9858-f479892ea5fd",
            "name": "Tribunal du travail du Hainaut",
            "department": "division Binche"
          },
          {
            "id": "81a65e24-15f2-4336-8bba-739c4f7becd9",
            "name": "Tribunal du travail du Hainaut",
            "department": "division Charleroi"
          },
          {
            "id": "12718cde-12e7-4fcf-856e-d72dfd25e3c6",
            "name": "Tribunal du travail du Hainaut",
            "department": "division La Louvière"
          },
          {
            "id": "f80396ec-a4f4-4fbb-91a2-a7720f80bb53",
            "name": "Tribunal du travail du Hainaut",
            "department": "division Mons"
          },
          {
            "id": "18367fbf-4a74-4030-9831-9a8155b1bb5c",
            "name": "Tribunal du travail du Hainaut",
            "department": "division Mouscron"
          },
          {
            "id": "178919f3-6dbb-47cc-bde0-2e3d12b68925",
            "name": "Tribunal du travail du Hainaut",
            "department": "division Tournai"
          },
          {
            "id": "e37e3a34-23b1-4318-ba40-d139d45afd9c",
            "name": "Tribunal du travail francophone de Bruxelles",
            "department": null
          }
        ]
      }
    },
    {
      "endpoint": "^/creditors$",
      "response": {
        "status": 200,
        "body": [
          {
            "name": "NMBS",
            "address": "adres nmbs",
            "companyNumber": "0203.430.576",
            "iban": "BE91735414567476"
          },
          {
            "name": "NMBS anders",
            "address": null,
            "companyNumber": "0203.430.576",
            "iban": "BE91735414567476"
          },
          {
            "name": "Proximus",
            "address": "straat 1\n1234 gemeente",
            "companyNumber": "0202.239.951",
            "iban": "BE02663366543140"
          },
          {
            "name": "test strucured",
            "address": null,
            "companyNumber": null,
            "iban": ""
          }
        ]
      }
    },
    {
      "endpoint": "^/documents/[^/]+/payment-data$",
      "response": {
        "status": 200,
        "body": {
          "amount": 123.45,
          "counterpartName": "Proximus",
          "counterpartReference": "BE02663366543140",
          "remittanceInformationType": "STRUCTURED",
          "remittanceInformation": "242367903982"
        }
      }
    },
    {
      "endpoint": "^/financial-institutions$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": "abn_amro",
            "name": "ABN-AMRO",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/abn_amro.svg",
            "acquiredBy": null,
            "bic": "ABNANL2A",
            "authorizationModel": "single"
          },
          {
            "id": "argenta",
            "name": "Argenta",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/argenta.svg",
            "acquiredBy": null,
            "bic": "ARSPBE22",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "van_breda",
            "name": "Bank J. Van Breda & C°",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/van_breda.svg",
            "acquiredBy": null,
            "bic": "JVBABE22",
            "authorizationModel": "detailed"
          },
          {
            "id": "belfius",
            "name": "Belfius",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/belfius.svg",
            "acquiredBy": null,
            "bic": "GKCCBEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "beobank",
            "name": "Beobank",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/beobank.svg",
            "acquiredBy": null,
            "bic": "CTBKBEBX",
            "authorizationModel": "global"
          },
          {
            "id": "bnp",
            "name": "BNP Paribas Fortis",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
            "acquiredBy": null,
            "bic": "GEBABEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "bnp_business",
            "name": "BNP Paribas Fortis Business",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
            "acquiredBy": null,
            "bic": "GEBABEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "cbc",
            "name": "CBC",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/cbc.svg",
            "acquiredBy": null,
            "bic": "CREGBEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "crelan",
            "name": "Crelan",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/crelan.svg",
            "acquiredBy": null,
            "bic": "NICABEBB",
            "authorizationModel": "detailed"
          },
          {
            "id": "deutsche_bank",
            "name": "Deutsche Bank",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/deutsche_bank.svg",
            "acquiredBy": null,
            "bic": "DEUTBEBE",
            "authorizationModel": "detailed"
          },
          {
            "id": "europabank",
            "name": "Europabank",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/europabank.svg",
            "acquiredBy": null,
            "bic": "EURBBE99",
            "authorizationModel": "detailed"
          },
          {
            "id": "fintro",
            "name": "Fintro",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/fintro.svg",
            "acquiredBy": null,
            "bic": "GEBABEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "hello_bank",
            "name": "Hello bank!",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/hello_bank.svg",
            "acquiredBy": null,
            "bic": "GEBABEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "ing",
            "name": "ING",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/ing.svg",
            "acquiredBy": null,
            "bic": "BBRUBEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "kbc",
            "name": "KBC",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/kbc.svg",
            "acquiredBy": null,
            "bic": "KREDBEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "kbc_brussels",
            "name": "KBC Brussels",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/kbc_brussels.svg",
            "acquiredBy": null,
            "bic": "KREDBEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "keytrade",
            "name": "Keytrade",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/keytrade.svg",
            "acquiredBy": null,
            "bic": "KEYTBEBB",
            "authorizationModel": "detailed"
          },
          {
            "id": "nagelmackers",
            "name": "Nagelmackers",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/nagelmackers.svg",
            "acquiredBy": null,
            "bic": "BNAGBEBB",
            "authorizationModel": "detailed"
          },
          {
            "id": "vdk",
            "name": "VDK",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/vdk.svg",
            "acquiredBy": null,
            "bic": "VDSPBE91",
            "authorizationModel": "detailed"
          }
        ]
      }
    },
    {
      "endpoint": "^/iban-validations/[^/]+$",
      "response": {
        "status": 200,
        "body": {
          "valid": true
        }
      }
    },
    {
      "endpoint": "^/iban-validations/BE00$",
      "response": {
        "status": 200,
        "body": {
          "valid": false
        }
      }
    },
    {
      "endpoint": "^/isabel/authorization-url$",
      "response": {
        "status": 200,
        "body": "https://auth.beta.isabel.be/auth/realms/isabel/protocol/openid-connect/auth?response_type=code&client_id=48697cfb-dc38-4ed6-9705-f69f97c455ff&scope=AI%20PI%20offline_access&redirect_uri=https%3A%2F%2Fbusiness-dev.roov.app%2Fisabel%2Finit&ui_locales=nl"
      }
    },
    {
      "endpoint": "^/isabel/connections$",
      "response": {
        "status": 200,
        "body": []
      }
    },
    {
      "endpoint": "^/justices-peace$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": "a30d5869-b1d7-4cfb-a958-2eff7999b4c7",
            "district": "Arrondissement Antwerpen",
            "name": "Antwerpen 1",
            "address": {
              "street": "Bolivarplaats",
              "number": "20 b19",
              "postalCode": "2000",
              "city": "Antwerpen"
            },
            "reportTemplates": null
          },
          {
            "id": "053f378b-e2e8-4b1e-97fe-2b0c6627b958",
            "district": "Arrondissement Antwerpen",
            "name": "Antwerpen 2",
            "address": {
              "street": "Bolivarplaats",
              "number": "20 b19",
              "postalCode": "2000",
              "city": "Antwerpen"
            },
            "reportTemplates": null
          },
          {
            "id": "82fb6007-8532-4062-95c8-c0c7619a89ef",
            "district": "Arrondissement Antwerpen",
            "name": "Antwerpen 3",
            "address": {
              "street": "Bolivarplaats",
              "number": "20 b19",
              "postalCode": "2000",
              "city": "Antwerpen"
            },
            "reportTemplates": null
          },
          {
            "id": "0d4a6c54-e361-4420-912d-4116e955931e",
            "district": "Arrondissement Antwerpen",
            "name": "Antwerpen 4",
            "address": {
              "street": "Bolivarplaats",
              "number": "20 b19",
              "postalCode": "2000",
              "city": "Antwerpen"
            },
            "reportTemplates": null
          },
          {
            "id": "8b0e0f02-f526-4914-bef6-0226fa9d3dcd",
            "district": "Arrondissement Antwerpen",
            "name": "Antwerpen 5",
            "address": {
              "street": "Bolivarplaats",
              "number": "20 b19",
              "postalCode": "2000",
              "city": "Antwerpen"
            },
            "reportTemplates": null
          },
          {
            "id": "826e5bbc-dada-4e07-904b-05e5270b63a1",
            "district": "Arrondissement Antwerpen",
            "name": "Antwerpen 6",
            "address": {
              "street": "Bolivarplaats",
              "number": "20 b19",
              "postalCode": "2000",
              "city": "Antwerpen"
            },
            "reportTemplates": null
          },
          {
            "id": "1b87b489-95da-4899-9883-0ef2b5ff98de",
            "district": "Arrondissement Antwerpen",
            "name": "Antwerpen 7",
            "address": {
              "street": "Bolivarplaats",
              "number": "20 b19",
              "postalCode": "2000",
              "city": "Antwerpen"
            },
            "reportTemplates": null
          },
          {
            "id": "7b9cc1cd-88cf-41d4-8755-ab691ec33c34",
            "district": "Arrondissement Antwerpen",
            "name": "Boom",
            "address": {
              "street": "Jozef V. Cleemputplein",
              "number": "8",
              "postalCode": "2850",
              "city": "Boom"
            },
            "reportTemplates": null
          },
          {
            "id": "b8bf182a-9061-4dd9-98f3-14254beac20c",
            "district": "Arrondissement Antwerpen",
            "name": "Brasschaat",
            "address": {
              "street": "Hemelakkers",
              "number": "65 - 67",
              "postalCode": "2930",
              "city": "Brasschaat"
            },
            "reportTemplates": null
          },
          {
            "id": "bfc55be0-6855-4654-a365-a604bc3a6baf",
            "district": "Arrondissement Antwerpen",
            "name": "Deurne",
            "address": {
              "street": "Cogelsplein",
              "number": "46",
              "postalCode": "2100",
              "city": "Deurne"
            },
            "reportTemplates": null
          },
          {
            "id": "9895112a-1667-4c0b-9781-f52133bccca6",
            "district": "Arrondissement Antwerpen",
            "name": "Eerste kanton Mol-Geel",
            "address": {
              "street": "Molderdijk",
              "number": "7",
              "postalCode": "2400",
              "city": "Mol"
            },
            "reportTemplates": null
          },
          {
            "id": "f0125b21-a1c4-4d1c-bbc4-9f6b5f096f5d",
            "district": "Arrondissement Antwerpen",
            "name": "Eerste kanton Turnhout",
            "address": {
              "street": "Kasteelplein",
              "number": "11",
              "postalCode": "2300",
              "city": "Turnhout"
            },
            "reportTemplates": null
          },
          {
            "id": "e3ff385f-c2f6-4925-9023-34b5fa4574fe",
            "district": "Arrondissement Antwerpen",
            "name": "Heist-op-den-Berg",
            "address": {
              "street": "Kerkhofstraat",
              "number": "2",
              "postalCode": "2220",
              "city": "Heist-op-den-Berg"
            },
            "reportTemplates": null
          },
          {
            "id": "44a795bc-357a-4131-bbbe-fa5fd784af4a",
            "district": "Arrondissement Antwerpen",
            "name": "Kapellen",
            "address": {
              "street": "Dennenburgdreef",
              "number": "8",
              "postalCode": "2950",
              "city": "Kapellen"
            },
            "reportTemplates": null
          },
          {
            "id": "200fea22-f6d0-440b-b722-0176f33c4b5c",
            "district": "Arrondissement Antwerpen",
            "name": "Kontich",
            "address": {
              "street": "Mechelsesteenweg",
              "number": "83",
              "postalCode": "2550",
              "city": "Kontich"
            },
            "reportTemplates": null
          },
          {
            "id": "7d841197-f20a-4964-a94c-b4c58dca16f3",
            "district": "Arrondissement Antwerpen",
            "name": "Lier",
            "address": {
              "street": "Kruisbogenstraat",
              "number": "24",
              "postalCode": "2500",
              "city": "Lier"
            },
            "reportTemplates": null
          },
          {
            "id": "27d359a0-f612-43b2-857f-8e68a099c513",
            "district": "Arrondissement Antwerpen",
            "name": "Mechelen",
            "address": {
              "street": "Voochtstraat",
              "number": "7",
              "postalCode": "2800",
              "city": "Mechelen"
            },
            "reportTemplates": null
          },
          {
            "id": "89c0ed25-851b-41f1-8db9-18739763bddc",
            "district": "Arrondissement Antwerpen",
            "name": "Merksem",
            "address": {
              "street": "Maantjessteenweg",
              "number": "133",
              "postalCode": "2170",
              "city": "Merksem"
            },
            "reportTemplates": null
          },
          {
            "id": "66972bf8-77b7-409c-9c43-1a0048fa66f1",
            "district": "Arrondissement Antwerpen",
            "name": "Tweede kanton Mol-Geel",
            "address": {
              "street": "Molderdijk",
              "number": "7",
              "postalCode": "2400",
              "city": "Mol"
            },
            "reportTemplates": null
          },
          {
            "id": "15380756-b536-47f6-a438-c683bd6e6277",
            "district": "Arrondissement Antwerpen",
            "name": "Tweede kanton Turnhout",
            "address": {
              "street": "Kasteelplein",
              "number": "11",
              "postalCode": "2300",
              "city": "Turnhout"
            },
            "reportTemplates": null
          },
          {
            "id": "a7f5fcaa-2f00-4a1a-9c46-5633ef19bc39",
            "district": "Arrondissement Antwerpen",
            "name": "Westerlo",
            "address": {
              "street": "Bistplein",
              "number": "13",
              "postalCode": "2260",
              "city": "Westerlo"
            },
            "reportTemplates": null
          },
          {
            "id": "5913ab2e-ffa5-4f23-837f-64ccb0433de7",
            "district": "Arrondissement Antwerpen",
            "name": "Willebroek",
            "address": {
              "street": "Kloosterstraat",
              "number": "18",
              "postalCode": "2830",
              "city": "Willebroek"
            },
            "reportTemplates": null
          },
          {
            "id": "04507b50-22db-4bc7-9fbe-d875c6774757",
            "district": "Arrondissement Antwerpen",
            "name": "Zandhoven",
            "address": {
              "street": "Amalbergastraat",
              "number": "13",
              "postalCode": "2240",
              "city": "Zandhoven"
            },
            "reportTemplates": null
          },
          {
            "id": "b7b07fac-0109-4bf1-823d-4137b3d76029",
            "district": "Arrondissement Brussel",
            "name": "Asse",
            "address": {
              "street": "Neerstraat",
              "number": "11",
              "postalCode": "1730",
              "city": "Asse"
            },
            "reportTemplates": null
          },
          {
            "id": "9fb32d48-3ee4-479a-a355-d1d9a4b3b351",
            "district": "Arrondissement Brussel",
            "name": "Halle",
            "address": {
              "street": "Zuster Bernardastraat",
              "number": "32",
              "postalCode": "1500",
              "city": "Halle"
            },
            "reportTemplates": null
          },
          {
            "id": "39661ba5-87c4-427b-b772-b83ca421b9d0",
            "district": "Arrondissement Brussel",
            "name": "Lennik",
            "address": {
              "street": "Alfred Algoetstraat",
              "number": "31",
              "postalCode": "1750",
              "city": "Lennik"
            },
            "reportTemplates": null
          },
          {
            "id": "c58da159-f6a5-4bfb-a91a-58536ff4ad81",
            "district": "Arrondissement Brussel",
            "name": "Meise",
            "address": {
              "street": "Gemeenteplein",
              "number": "15",
              "postalCode": "1861",
              "city": "Meise"
            },
            "reportTemplates": null
          },
          {
            "id": "d01eba89-8245-4cd7-8b3f-8de77fb72bf1",
            "district": "Arrondissement Brussel",
            "name": "Sint-Genesius-Rode",
            "address": {
              "street": "Zoniënwoudlaan",
              "number": "83",
              "postalCode": "1640",
              "city": "Sint-Genesius-Rode"
            },
            "reportTemplates": null
          },
          {
            "id": "0f4b445f-a30f-4fa4-ac63-f56a1109f283",
            "district": "Arrondissement Brussel",
            "name": "Vilvoorde",
            "address": {
              "street": "Luchthavenlaan",
              "number": "4",
              "postalCode": "1800",
              "city": "Vilvoorde"
            },
            "reportTemplates": null
          },
          {
            "id": "5e85cd42-b2e3-4f20-baf3-d8f96cbebf80",
            "district": "Arrondissement Brussel",
            "name": "Zaventem",
            "address": {
              "street": "Leuvensesteenweg",
              "number": "510/bus 36",
              "postalCode": "1930",
              "city": "Zaventem"
            },
            "reportTemplates": null
          },
          {
            "id": "efa235bf-ed1c-4556-8bde-57e37e621266",
            "district": "Arrondissement Leuven",
            "name": "Aarschot",
            "address": {
              "street": "Statiestraat",
              "number": "3",
              "postalCode": "3200",
              "city": "Aarschot"
            },
            "reportTemplates": null
          },
          {
            "id": "28cefce5-4b1a-4817-b455-963e28df0547",
            "district": "Arrondissement Leuven",
            "name": "Diest",
            "address": {
              "street": "Koning Albertstraat",
              "number": "12",
              "postalCode": "3290",
              "city": "Diest"
            },
            "reportTemplates": null
          },
          {
            "id": "e01235b3-ed8e-48cf-9b28-beee5c51e487",
            "district": "Arrondissement Leuven",
            "name": "Leuven 1",
            "address": {
              "street": "Vaartstraat",
              "number": "24",
              "postalCode": "3000",
              "city": "Leuven"
            },
            "reportTemplates": null
          },
          {
            "id": "0191c36b-51f9-4c9b-92ad-79f7ac0cb16a",
            "district": "Arrondissement Leuven",
            "name": "Leuven 2",
            "address": {
              "street": "Vaartstraat",
              "number": "24",
              "postalCode": "3000",
              "city": "Leuven"
            },
            "reportTemplates": null
          },
          {
            "id": "afc1105a-8a4d-4d29-82b5-2b2b46cf9770",
            "district": "Arrondissement Leuven",
            "name": "Leuven 3",
            "address": {
              "street": "Vaartstraat",
              "number": "24",
              "postalCode": "3000",
              "city": "Leuven"
            },
            "reportTemplates": null
          },
          {
            "id": "f7a7b82a-50bf-4f8a-b250-41d90a55926e",
            "district": "Arrondissement Leuven",
            "name": "Tienen",
            "address": {
              "street": "Grote Markt",
              "number": "8A",
              "postalCode": "3300",
              "city": "Tienen"
            },
            "reportTemplates": null
          },
          {
            "id": "75d801a9-ba2f-4753-8e15-bd2e03c138ba",
            "district": "Arrondissement Leuven",
            "name": "Zoutleeuw",
            "address": {
              "street": "Aen den Hoorn",
              "number": "15",
              "postalCode": "3440",
              "city": "Zoutleeuw"
            },
            "reportTemplates": null
          },
          {
            "id": "f90a9a83-b8e4-45cb-a70a-c5e6885bcb04",
            "district": "Arrondissement Limburg",
            "name": "Beringen",
            "address": {
              "street": "Pieter Bruegelstraat",
              "number": "8",
              "postalCode": "3580",
              "city": "Beringen"
            },
            "reportTemplates": null
          },
          {
            "id": "048f32cb-87ff-49cf-ac58-958a97fb3184",
            "district": "Arrondissement Limburg",
            "name": "Bilzen",
            "address": {
              "street": "Brugstraat",
              "number": "2",
              "postalCode": "3740",
              "city": "Bilzen"
            },
            "reportTemplates": null
          },
          {
            "id": "04e1ae05-359a-47ce-8e9f-c024757bb5d7",
            "district": "Arrondissement Limburg",
            "name": "Bree",
            "address": {
              "street": "Kloosterpoort",
              "number": "1 A000",
              "postalCode": "3960",
              "city": "Bree"
            },
            "reportTemplates": null
          },
          {
            "id": "5f158715-ec7e-4d72-a187-8fde23a2c6fe",
            "district": "Arrondissement Limburg",
            "name": "Genk",
            "address": {
              "street": "Brugstraat",
              "number": "2",
              "postalCode": "3740",
              "city": "Bilzen"
            },
            "reportTemplates": null
          },
          {
            "id": "12444a90-8504-459a-81b2-b2652d41f18e",
            "district": "Arrondissement Limburg",
            "name": "Hasselt 1",
            "address": {
              "street": "Parklaan",
              "number": "25 bus 7",
              "postalCode": "3500",
              "city": "Hasselt"
            },
            "reportTemplates": null
          },
          {
            "id": "19d5a726-3f11-4813-9497-2bfecf8531b8",
            "district": "Arrondissement Limburg",
            "name": "Hasselt 2",
            "address": {
              "street": "Parklaan",
              "number": "25 bus 8",
              "postalCode": "3500",
              "city": "Hasselt"
            },
            "reportTemplates": null
          },
          {
            "id": "8db53ea1-f55c-4464-85e6-95bb5797644d",
            "district": "Arrondissement Limburg",
            "name": "Houthalen - Helchteren",
            "address": {
              "street": "Pastorijstraat",
              "number": "30",
              "postalCode": "3530",
              "city": "Houthalen - Helchteren"
            },
            "reportTemplates": null
          },
          {
            "id": "b22626b5-0153-4b54-a2e9-906dee744c33",
            "district": "Arrondissement Limburg",
            "name": "Maasmechelen",
            "address": {
              "street": "Binnenhof",
              "number": "3",
              "postalCode": "3630",
              "city": "Maasmechelen"
            },
            "reportTemplates": null
          },
          {
            "id": "205cadbd-8855-4c4e-920c-2f5613bda9c7",
            "district": "Arrondissement Limburg",
            "name": "Pelt",
            "address": {
              "street": "Justitielaan",
              "number": "31",
              "postalCode": "3910",
              "city": "Pelt"
            },
            "reportTemplates": null
          },
          {
            "id": "d163a35c-eb14-45ed-bb33-d824cbaceba8",
            "district": "Arrondissement Limburg",
            "name": "Sint-Truiden",
            "address": {
              "street": "Kazernevest",
              "number": "10",
              "postalCode": "3800",
              "city": "Sint-Truiden"
            },
            "reportTemplates": null
          },
          {
            "id": "d5827a19-3963-418a-b528-6a551b604022",
            "district": "Arrondissement Limburg",
            "name": "Tongeren",
            "address": {
              "street": "Kielenstraat",
              "number": "22 bus 5",
              "postalCode": "3700",
              "city": "Tongeren"
            },
            "reportTemplates": null
          },
          {
            "id": "f2712972-86ce-4950-ab93-9f9bb4d6e20e",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Aalst 1",
            "address": {
              "street": "Dr. André Sierenstraat",
              "number": "16 bus 3/C",
              "postalCode": "9300",
              "city": "Aalst"
            },
            "reportTemplates": null
          },
          {
            "id": "e32c42f4-f55f-4093-bbca-3505526afc46",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Aalst 2",
            "address": {
              "street": "Dr. André Sierenstraat",
              "number": "16",
              "postalCode": "9300",
              "city": "Aalst"
            },
            "reportTemplates": null
          },
          {
            "id": "129640e3-09f6-400b-b8f7-5a43af78eaba",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Beveren",
            "address": {
              "street": "Gravendreef",
              "number": "3",
              "postalCode": "9120",
              "city": "Beveren"
            },
            "reportTemplates": null
          },
          {
            "id": "c8492e70-a382-4710-abbd-e3bd9a80ec79",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Deinze",
            "address": {
              "street": "Brielstraat",
              "number": "27",
              "postalCode": "9800",
              "city": "Deinze"
            },
            "reportTemplates": null
          },
          {
            "id": "0f719bba-36a3-4ce1-a898-de5af7d5dc11",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Dendermonde",
            "address": {
              "street": "Noordlaan",
              "number": "31/2",
              "postalCode": "9200",
              "city": "Dendermonde"
            },
            "reportTemplates": null
          },
          {
            "id": "b68e27ea-ca74-483b-b1bb-625fdca4f857",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Eeklo",
            "address": {
              "street": "Stationsstraat",
              "number": "21",
              "postalCode": "9900",
              "city": "Eeklo"
            },
            "reportTemplates": null
          },
          {
            "id": "3ecbfb5b-0f4e-44a7-88b2-43ab67821efe",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Gent 1",
            "address": {
              "street": "Opgeëistenlaan",
              "number": "401/F",
              "postalCode": "9000",
              "city": "Gent"
            },
            "reportTemplates": null
          },
          {
            "id": "9407697d-a53a-47d1-90fc-67a315275c53",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Gent 2",
            "address": {
              "street": "Opgeëistenlaan",
              "number": "401/F",
              "postalCode": "9000",
              "city": "Gent"
            },
            "reportTemplates": null
          },
          {
            "id": "68efab70-00f2-4ad1-8011-c30754b45d0a",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Gent 3",
            "address": {
              "street": "Opgeëistenlaan",
              "number": "401/F",
              "postalCode": "9000",
              "city": "Gent"
            },
            "reportTemplates": null
          },
          {
            "id": "49905927-6a01-40fb-b8c0-562fe867200f",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Gent 4",
            "address": {
              "street": "Opgeëistenlaan",
              "number": "401/F",
              "postalCode": "9000",
              "city": "Gent"
            },
            "reportTemplates": null
          },
          {
            "id": "dcf19aef-2c88-48bd-9e94-89e23691ac56",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Gent 5",
            "address": {
              "street": "Opgeëistenlaan",
              "number": "401/F",
              "postalCode": "9000",
              "city": "Gent"
            },
            "reportTemplates": null
          },
          {
            "id": "39b838b0-f570-49ae-95b5-e64f72a0978f",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Geraardsbergen",
            "address": {
              "street": "Kasteelstraat",
              "number": "58",
              "postalCode": "9660",
              "city": "Brakel"
            },
            "reportTemplates": null
          },
          {
            "id": "d70e0e3f-430e-4a7c-9b42-c7bd594ce346",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Hamme",
            "address": {
              "street": "Meulenbroekstraat",
              "number": "20",
              "postalCode": "9220",
              "city": "Hamme"
            },
            "reportTemplates": null
          },
          {
            "id": "da39b765-9c6d-466f-aad9-6facc99099db",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Herzele",
            "address": {
              "street": "Stationsstraat",
              "number": "6",
              "postalCode": "9550",
              "city": "Herzele"
            },
            "reportTemplates": null
          },
          {
            "id": "f8709bf1-a9c1-4f0f-b963-429f7a0f0bd7",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Lokeren",
            "address": {
              "street": "Markt",
              "number": "8",
              "postalCode": "9160",
              "city": "Lokeren"
            },
            "reportTemplates": null
          },
          {
            "id": "9e04c767-995d-440a-bd00-defe5ccbe22d",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Merelbeke",
            "address": {
              "street": "Hundelgemsesteenweg",
              "number": "622-624",
              "postalCode": "9820",
              "city": "Merelbeke"
            },
            "reportTemplates": null
          },
          {
            "id": "530709e0-fcd8-4f85-bee6-2433403784ed",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Ninove",
            "address": {
              "street": "Onderwijslaan",
              "number": "71",
              "postalCode": "9400",
              "city": "Ninove"
            },
            "reportTemplates": null
          },
          {
            "id": "f84f38a9-e64e-4645-b9e6-8b87af306cd8",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Oudenaarde",
            "address": {
              "street": "Beverstraat",
              "number": "78",
              "postalCode": "9700",
              "city": "Oudenaarde"
            },
            "reportTemplates": null
          },
          {
            "id": "c4d1774e-bf8e-49b1-b70a-284b9c19548a",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Sint-Niklaas",
            "address": {
              "street": "Kazernestraat",
              "number": "4-6",
              "postalCode": "9100",
              "city": "Sint-Niklaas"
            },
            "reportTemplates": null
          },
          {
            "id": "2fe04819-4e71-4188-b4fa-016d700b74bd",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Wetteren",
            "address": {
              "street": "Rode Heuvel",
              "number": "4",
              "postalCode": "9230",
              "city": "Wetteren"
            },
            "reportTemplates": null
          },
          {
            "id": "80100853-32a6-4ea8-af6a-a8ef596957ea",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Zelzate",
            "address": {
              "street": "Suikerkaai",
              "number": "10",
              "postalCode": "9060",
              "city": "Zelzate"
            },
            "reportTemplates": null
          },
          {
            "id": "e3b7c469-9c2c-479f-ac8c-b77529cd91f8",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Brugge I",
            "address": {
              "street": "Kazernevest",
              "number": "4",
              "postalCode": "8000",
              "city": "Brugge"
            },
            "reportTemplates": null
          },
          {
            "id": "af371c8b-34b4-4803-bbd8-c16437a4aa8f",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Brugge II",
            "address": {
              "street": "Kazernevest",
              "number": "4",
              "postalCode": "8000",
              "city": "Brugge"
            },
            "reportTemplates": null
          },
          {
            "id": "36380970-63d4-401f-a900-bf31499215b5",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Brugge III",
            "address": {
              "street": "Kazernevest",
              "number": "4",
              "postalCode": "8000",
              "city": "Brugge"
            },
            "reportTemplates": null
          },
          {
            "id": "94c67cfe-1d4b-46d0-a700-ea38a04cb690",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Brugge IV",
            "address": {
              "street": "Kazernevest",
              "number": "4",
              "postalCode": "8000",
              "city": "Brugge"
            },
            "reportTemplates": null
          },
          {
            "id": "9d268c64-b81a-462d-933d-93086726649e",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Ieper",
            "address": {
              "street": "Korte Meersstraat",
              "number": "18",
              "postalCode": "8900",
              "city": "Ieper"
            },
            "reportTemplates": null
          },
          {
            "id": "3ad4cf65-18ab-4865-91d7-2932257b046a",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Izegem",
            "address": {
              "street": "Kasteelstraat",
              "number": "15",
              "postalCode": "8870",
              "city": "Izegem"
            },
            "reportTemplates": null
          },
          {
            "id": "e2114641-8574-40ec-8f03-3d541641137e",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Kortrijk I",
            "address": {
              "street": "Beheerstraat",
              "number": "41",
              "postalCode": "8500",
              "city": "Kortrijk"
            },
            "reportTemplates": null
          },
          {
            "id": "46b53cd8-75b2-4525-8198-206d68ad7bab",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Kortrijk II",
            "address": {
              "street": "Beheerstraat",
              "number": "41",
              "postalCode": "8500",
              "city": "Kortrijk"
            },
            "reportTemplates": null
          },
          {
            "id": "53568f32-141f-4599-b730-6605b0ac80dd",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Menen",
            "address": {
              "street": "Volkslaan",
              "number": "302/0101",
              "postalCode": "8930",
              "city": "Menen"
            },
            "reportTemplates": null
          },
          {
            "id": "2b164e7d-8f76-4566-9d62-84258ef60552",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Oostende I",
            "address": {
              "street": "Canadaplein",
              "number": "1",
              "postalCode": "8400",
              "city": "Oostende"
            },
            "reportTemplates": null
          },
          {
            "id": "01cecfbb-f3a2-4411-aca2-eb00d890401d",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Oostende II",
            "address": {
              "street": "Canadaplein",
              "number": "1",
              "postalCode": "8400",
              "city": "Oostende"
            },
            "reportTemplates": null
          },
          {
            "id": "4becd89f-cfe4-4756-81e6-7c510e9b188d",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Poperinge",
            "address": {
              "street": "Burgemeester Bertenplein",
              "number": "21",
              "postalCode": "8970",
              "city": "Poperinge"
            },
            "reportTemplates": null
          },
          {
            "id": "1d3aff18-29c9-47ce-8438-a4341afa9712",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Roeselare",
            "address": {
              "street": "Rondekomstraat",
              "number": "22",
              "postalCode": "8800",
              "city": "Roeselare"
            },
            "reportTemplates": null
          },
          {
            "id": "7d07be0d-fb54-40c3-b196-74844d879ecd",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Tielt",
            "address": {
              "street": "Tramstraat",
              "number": "48",
              "postalCode": "8700",
              "city": "Tielt"
            },
            "reportTemplates": null
          },
          {
            "id": "db6d6d9a-d0bc-47ad-847d-295bf9ed5108",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Torhout",
            "address": {
              "street": "Elisabetlaan",
              "number": "29",
              "postalCode": "8820",
              "city": "Torhout"
            },
            "reportTemplates": null
          },
          {
            "id": "51d8c632-bc72-4990-a559-22ef917867b2",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Veurne",
            "address": {
              "street": "Peter Benoitlaan",
              "number": "2",
              "postalCode": "8630",
              "city": "Veurne"
            },
            "reportTemplates": null
          },
          {
            "id": "d69c04eb-2757-4a52-983d-9d660481528a",
            "district": "Arrondissement West-Vlaanderen",
            "name": "Waregem",
            "address": {
              "street": "Stationstraat",
              "number": "127",
              "postalCode": "8790",
              "city": "Waregem"
            },
            "reportTemplates": null
          },
          {
            "id": "8c1d4402-6612-4c31-9075-1984cbb9f504",
            "district": "L'arrondissement d'Eupen",
            "name": "Premier canton d'Eupen-Saint Vith",
            "address": {
              "street": "Rathausplatz",
              "number": "4",
              "postalCode": "4700",
              "city": "Eupen"
            },
            "reportTemplates": null
          },
          {
            "id": "e31a62a5-2f90-469e-b962-00ab75703bb5",
            "district": "L'arrondissement d'Eupen",
            "name": "Second canton d'Eupen-Saint Vith",
            "address": {
              "street": "Rathausplatz",
              "number": "4",
              "postalCode": "4700",
              "city": "Eupen"
            },
            "reportTemplates": null
          },
          {
            "id": "0c9c7113-c932-41e8-a247-90e7338ef416",
            "district": "L'arrondissement de Brabant Wallon",
            "name": "Braine-l'Alleud",
            "address": {
              "street": "Rue Pierre Flamand",
              "number": "64",
              "postalCode": "1420",
              "city": "Braine-l'Alleud"
            },
            "reportTemplates": null
          },
          {
            "id": "43d00981-5941-4cf6-8095-02ac5634a1c9",
            "district": "L'arrondissement de Brabant Wallon",
            "name": "Jodoigne",
            "address": {
              "street": "Avenue des Commandants Borlée",
              "number": "42",
              "postalCode": "1370",
              "city": "Jodoigne"
            },
            "reportTemplates": null
          },
          {
            "id": "3d4aa8f9-1f4a-439a-958c-e22be399abe8",
            "district": "L'arrondissement de Brabant Wallon",
            "name": "Nivelles",
            "address": {
              "street": "Rue Clarisse",
              "number": "115",
              "postalCode": "1400",
              "city": "Nivelles"
            },
            "reportTemplates": null
          },
          {
            "id": "d80f19b3-25c3-48a1-adbf-becf4502a979",
            "district": "L'arrondissement de Brabant Wallon",
            "name": "Wavre I",
            "address": {
              "street": "Place de l'Hôtel de Ville",
              "number": "",
              "postalCode": "1300",
              "city": "Wavre"
            },
            "reportTemplates": null
          },
          {
            "id": "93ac33f9-a806-48bb-85e6-15db0b7f5387",
            "district": "L'arrondissement de Brabant Wallon",
            "name": "Wavre II",
            "address": {
              "street": "Chaussée de Bruxelles",
              "number": "8",
              "postalCode": "1300",
              "city": "Wavre"
            },
            "reportTemplates": null
          },
          {
            "id": "6db20903-eb2b-45c9-bd85-709dc7b63eac",
            "district": "L'arrondissement de Bruxelles",
            "name": "Anderlecht 1er canton",
            "address": {
              "street": "Place de la Résistance",
              "number": "3",
              "postalCode": "1070",
              "city": "Anderlecht"
            },
            "reportTemplates": null
          },
          {
            "id": "283d03b9-5b1c-437f-a414-735c13dc34eb",
            "district": "L'arrondissement de Bruxelles",
            "name": "Anderlecht 2ième canton",
            "address": {
              "street": "Place de la Résistance",
              "number": "3",
              "postalCode": "1070",
              "city": "Anderlecht"
            },
            "reportTemplates": null
          },
          {
            "id": "aee2a463-9857-4927-aec7-09834014a07b",
            "district": "L'arrondissement de Bruxelles",
            "name": "Auderghem",
            "address": {
              "street": "rue de l’Etang",
              "number": "4",
              "postalCode": "1040",
              "city": "Etterbeek"
            },
            "reportTemplates": null
          },
          {
            "id": "5820b492-760e-4f25-903f-855a46591939",
            "district": "L'arrondissement de Bruxelles",
            "name": "Bruxelles 1er canton",
            "address": {
              "street": "Place Poelaert",
              "number": "3 boîte 5",
              "postalCode": "1000",
              "city": "Bruxelles"
            },
            "reportTemplates": null
          },
          {
            "id": "0153319a-5f13-4072-a85c-1158ea7db903",
            "district": "L'arrondissement de Bruxelles",
            "name": "Bruxelles 2ième canton",
            "address": {
              "street": "Place Poelaert",
              "number": "3 boîte 5",
              "postalCode": "1000",
              "city": "Bruxelles"
            },
            "reportTemplates": null
          },
          {
            "id": "04801535-0110-4060-8d3a-9016b7f03eba",
            "district": "L'arrondissement de Bruxelles",
            "name": "Bruxelles 3ième canton",
            "address": {
              "street": "rue Fransman",
              "number": "89",
              "postalCode": "1020",
              "city": "Bruxelles"
            },
            "reportTemplates": null
          },
          {
            "id": "6240e1a3-49ca-4c47-9112-270f5f65eb70",
            "district": "L'arrondissement de Bruxelles",
            "name": "Bruxelles 4ième canton",
            "address": {
              "street": "rue Fransman",
              "number": "89",
              "postalCode": "1020",
              "city": "Bruxelles"
            },
            "reportTemplates": null
          },
          {
            "id": "741d0f26-47aa-41c4-92d0-1acdfe8aa097",
            "district": "L'arrondissement de Bruxelles",
            "name": "Etterbeek",
            "address": {
              "street": "rue de l’Etang",
              "number": "4",
              "postalCode": "1040",
              "city": "Etterbeek"
            },
            "reportTemplates": null
          },
          {
            "id": "fb75ef3d-9413-4ea7-a7b5-6658701d8371",
            "district": "L'arrondissement de Bruxelles",
            "name": "Forest",
            "address": {
              "street": "Chaussée d'Alsemberg",
              "number": "298",
              "postalCode": "1190",
              "city": "Forest"
            },
            "reportTemplates": null
          },
          {
            "id": "2412c89f-6ba8-4674-a21d-10090d9e6913",
            "district": "L'arrondissement de Bruxelles",
            "name": "Ganshoren",
            "address": {
              "street": "Rue Fransman",
              "number": "89",
              "postalCode": "1020",
              "city": "Ganshoren"
            },
            "reportTemplates": null
          },
          {
            "id": "b7345502-50e7-4168-871b-14c48204be3b",
            "district": "L'arrondissement de Bruxelles",
            "name": "Ixelles",
            "address": {
              "street": "Place Poelaert",
              "number": "3",
              "postalCode": "1000",
              "city": "Ixelles"
            },
            "reportTemplates": null
          },
          {
            "id": "995f3147-ddc9-4033-b9c8-ef34b29d2172",
            "district": "L'arrondissement de Bruxelles",
            "name": "Jette",
            "address": {
              "street": "Place Cardinal Mercier",
              "number": "11",
              "postalCode": "1090",
              "city": "Jette"
            },
            "reportTemplates": null
          },
          {
            "id": "0f9ffab9-49a0-412b-81e0-ea4ad023951d",
            "district": "L'arrondissement de Bruxelles",
            "name": "Molenbeek-Saint-Jean",
            "address": {
              "street": "Rue du Niveau",
              "number": "7",
              "postalCode": "1080",
              "city": "Molenbeek-Saint-Jean"
            },
            "reportTemplates": null
          },
          {
            "id": "d30e27d1-9da1-4a7e-b6a3-27d39f9eaea1",
            "district": "L'arrondissement de Bruxelles",
            "name": "Saint-Gilles",
            "address": {
              "street": "Parvis Saint-Gilles",
              "number": "1",
              "postalCode": "1060",
              "city": "Saint-Gilles"
            },
            "reportTemplates": null
          },
          {
            "id": "92b0a9a7-84b2-4211-acfe-c377f76500e7",
            "district": "L'arrondissement de Bruxelles",
            "name": "Saint-Josse-ten-Noode",
            "address": {
              "street": "Avenue de l’Astronomie",
              "number": "30/8",
              "postalCode": "1210",
              "city": "Saint-Josse-ten-Noode"
            },
            "reportTemplates": null
          },
          {
            "id": "41fe291d-dc53-489b-ac32-6f9454857368",
            "district": "L'arrondissement de Bruxelles",
            "name": "Schaerbeek 1er canton",
            "address": {
              "street": "Rue Royale",
              "number": "271-273",
              "postalCode": "1030",
              "city": "Schaerbeek"
            },
            "reportTemplates": null
          },
          {
            "id": "0f115d1b-ab7c-40fd-b20a-28ea50bca269",
            "district": "L'arrondissement de Bruxelles",
            "name": "Schaerbeek 2e canton",
            "address": {
              "street": "Rue Royale",
              "number": "271-273",
              "postalCode": "1030",
              "city": "Schaerbeek"
            },
            "reportTemplates": null
          },
          {
            "id": "035db456-de9e-459f-bd69-3328b1bb0a47",
            "district": "L'arrondissement de Bruxelles",
            "name": "Uccle",
            "address": {
              "street": "Place Jean Vander Elst,",
              "number": "29",
              "postalCode": "1180",
              "city": "Uccle"
            },
            "reportTemplates": null
          },
          {
            "id": "83b59618-0e9a-44cf-bbe3-503fc73ce0b8",
            "district": "L'arrondissement de Bruxelles",
            "name": "Woluwe-Saint-Pierre",
            "address": {
              "street": "Avenue Grandchamp",
              "number": "147",
              "postalCode": "1150",
              "city": "Woluwe-Saint-Pierre"
            },
            "reportTemplates": null
          },
          {
            "id": "f8074ee2-8d2b-4053-82d8-883b1d0333e0",
            "district": "L'arrondissement de Hainaut",
            "name": "Ath",
            "address": {
              "street": "Place des Capucins",
              "number": "1",
              "postalCode": "7800",
              "city": "Ath"
            },
            "reportTemplates": null
          },
          {
            "id": "0a2218d3-c130-4bd8-b960-12d3ebe50ff3",
            "district": "L'arrondissement de Hainaut",
            "name": "Binche",
            "address": {
              "street": "Avenue Charles Deliège",
              "number": "54",
              "postalCode": "7130",
              "city": "Binche"
            },
            "reportTemplates": null
          },
          {
            "id": "f60b2b18-4a07-4f8c-8498-21eb8f267e48",
            "district": "L'arrondissement de Hainaut",
            "name": "Boussu-Colfontaine I",
            "address": {
              "street": "Rue Grande Campagne",
              "number": "34",
              "postalCode": "7301",
              "city": "Boussu"
            },
            "reportTemplates": null
          },
          {
            "id": "fe1d8f44-365b-4f90-a5f7-b6c453af63e1",
            "district": "L'arrondissement de Hainaut",
            "name": "Boussu-Colfontaine II",
            "address": {
              "street": "Rue Grande Campagne",
              "number": "34",
              "postalCode": "7301",
              "city": "Boussu"
            },
            "reportTemplates": null
          },
          {
            "id": "488f6ad0-a949-4d14-acf0-9759a8cb1c59",
            "district": "L'arrondissement de Hainaut",
            "name": "Charleroi I",
            "address": {
              "street": "Avenue Général Michel",
              "number": "2 boîte 3",
              "postalCode": "6000",
              "city": "Charleroi"
            },
            "reportTemplates": null
          },
          {
            "id": "9b13f0ab-c1f4-4d8f-a42d-193fb3458574",
            "district": "L'arrondissement de Hainaut",
            "name": "Charleroi II",
            "address": {
              "street": "Avenue Général Michel",
              "number": "2 boîte 3",
              "postalCode": "6000",
              "city": "Charleroi"
            },
            "reportTemplates": null
          },
          {
            "id": "b494bce3-01c7-478f-87a1-681813cf39e6",
            "district": "L'arrondissement de Hainaut",
            "name": "Charleroi III",
            "address": {
              "street": "Rue de Beaumont",
              "number": "28",
              "postalCode": "6030",
              "city": "Marchienne-au-Pont"
            },
            "reportTemplates": null
          },
          {
            "id": "602643c5-e0da-4487-9516-1e055f1be847",
            "district": "L'arrondissement de Hainaut",
            "name": "Charleroi IV",
            "address": {
              "street": "Rue de Beaumont",
              "number": "28",
              "postalCode": "6030",
              "city": "Marchienne-au-Pont"
            },
            "reportTemplates": null
          },
          {
            "id": "c74c5bce-6e28-4a9b-8128-003c564a9039",
            "district": "L'arrondissement de Hainaut",
            "name": "Chimay",
            "address": {
              "street": "Grand’Place",
              "number": "13",
              "postalCode": "6460",
              "city": "Chimay"
            },
            "reportTemplates": null
          },
          {
            "id": "cf548109-03da-438c-a78e-62e28c1c69ca",
            "district": "L'arrondissement de Hainaut",
            "name": "Châtelet",
            "address": {
              "street": "Place de l'Hôtel de Ville",
              "number": "9",
              "postalCode": "6200",
              "city": "Châtelet"
            },
            "reportTemplates": null
          },
          {
            "id": "87c0dd71-f4d6-42a2-8364-71712a0cc307",
            "district": "L'arrondissement de Hainaut",
            "name": "La Louvière",
            "address": {
              "street": "Rue des Carrelages",
              "number": "18",
              "postalCode": "7100",
              "city": "La Louvière"
            },
            "reportTemplates": null
          },
          {
            "id": "6492f085-607d-449f-a23e-ba3613e3cbd1",
            "district": "L'arrondissement de Hainaut",
            "name": "Leuze-en-Hainaut",
            "address": {
              "street": "Rue d'Ath",
              "number": "33",
              "postalCode": "7900",
              "city": "Leuze-en-Hainaut"
            },
            "reportTemplates": null
          },
          {
            "id": "ef4d9fe0-7702-4e61-804a-699fc402e6c0",
            "district": "L'arrondissement de Hainaut",
            "name": "Mons I",
            "address": {
              "street": "Rue de Nimy",
              "number": "16/1",
              "postalCode": "7000",
              "city": "Mons"
            },
            "reportTemplates": null
          },
          {
            "id": "4dc0384c-4322-4b98-a0e0-5cd75d1dfab1",
            "district": "L'arrondissement de Hainaut",
            "name": "Mons II",
            "address": {
              "street": "Rue de Nimy",
              "number": "16/2",
              "postalCode": "7000",
              "city": "Mons"
            },
            "reportTemplates": null
          },
          {
            "id": "66571161-4a3f-4b36-a0c6-1202f2a262ca",
            "district": "L'arrondissement de Hainaut",
            "name": "Mouscron",
            "address": {
              "street": "Place Lamartine",
              "number": "1",
              "postalCode": "7700",
              "city": "Mouscron"
            },
            "reportTemplates": null
          },
          {
            "id": "d53e3427-ad52-436d-b2b4-bd77c63b3168",
            "district": "L'arrondissement de Hainaut",
            "name": "Seneffe",
            "address": {
              "street": "Rue Rouge Croix",
              "number": "3",
              "postalCode": "7180",
              "city": "Seneffe"
            },
            "reportTemplates": null
          },
          {
            "id": "04f052ef-9e69-461b-84b4-c5db3bc58311",
            "district": "L'arrondissement de Hainaut",
            "name": "Soignies",
            "address": {
              "street": "Rue de la Station",
              "number": "82",
              "postalCode": "7060",
              "city": "Soignies"
            },
            "reportTemplates": null
          },
          {
            "id": "fecfe310-c1ce-494c-b5b2-69d3dc7c7a76",
            "district": "L'arrondissement de Hainaut",
            "name": "Thuin",
            "address": {
              "street": "Grand'Rue",
              "number": "46",
              "postalCode": "6530",
              "city": "Thuin"
            },
            "reportTemplates": null
          },
          {
            "id": "961a56e9-bf59-43f0-b42c-fba6d29de415",
            "district": "L'arrondissement de Hainaut",
            "name": "Tournai I",
            "address": {
              "street": "Boulevard Léopold",
              "number": "72",
              "postalCode": "7500",
              "city": "Tournai"
            },
            "reportTemplates": null
          },
          {
            "id": "ad40a422-bc55-4a6a-8e26-3223d1f258a9",
            "district": "L'arrondissement de Hainaut",
            "name": "Tournai II",
            "address": {
              "street": "Boulevard Léopold",
              "number": "72",
              "postalCode": "7500",
              "city": "Tournai"
            },
            "reportTemplates": null
          },
          {
            "id": "f3e0299b-91e4-44ac-b05d-df7a2c019592",
            "district": "L'arrondissement de Liège",
            "name": "Fléron",
            "address": {
              "street": "Rue du Bay-Bonnet",
              "number": "15",
              "postalCode": "4620",
              "city": "Fléron"
            },
            "reportTemplates": null
          },
          {
            "id": "bc69025f-f50c-4805-8650-0e10ad1356aa",
            "district": "L'arrondissement de Liège",
            "name": "Grâce-Hollogne",
            "address": {
              "street": "Rue de l'Hotel Communal",
              "number": "30",
              "postalCode": "4460",
              "city": "Grâce-Hollogne"
            },
            "reportTemplates": null
          },
          {
            "id": "c9455120-129e-4157-a049-73382171e691",
            "district": "L'arrondissement de Liège",
            "name": "Herstal",
            "address": {
              "street": "Large Voie",
              "number": "49",
              "postalCode": "4040",
              "city": "Herstal"
            },
            "reportTemplates": null
          },
          {
            "id": "26e66ca9-ecdb-4c25-bd9a-de47526b62ec",
            "district": "L'arrondissement de Liège",
            "name": "Huy I",
            "address": {
              "street": "Quai d'Arona",
              "number": "4",
              "postalCode": "4500",
              "city": "Huy"
            },
            "reportTemplates": null
          },
          {
            "id": "f0ac1e2a-0eb6-464f-ab25-9bc509c44239",
            "district": "L'arrondissement de Liège",
            "name": "Huy II",
            "address": {
              "street": "Quai d'Arona",
              "number": "4",
              "postalCode": "4500",
              "city": "Huy"
            },
            "reportTemplates": null
          },
          {
            "id": "9b5641cd-6e68-4d96-9b25-6a1c16258996",
            "district": "L'arrondissement de Liège",
            "name": "Limbourg",
            "address": {
              "street": "Rathausplatz",
              "number": "4",
              "postalCode": "4700",
              "city": "Eupen"
            },
            "reportTemplates": null
          },
          {
            "id": "69055eaf-aca3-4cb3-8bea-8fd062c46ae7",
            "district": "L'arrondissement de Liège",
            "name": "Liège I",
            "address": {
              "street": "Rue de Bruxelles",
              "number": "2/0005",
              "postalCode": "4000",
              "city": "Liège"
            },
            "reportTemplates": null
          },
          {
            "id": "fe677794-cdfe-4af2-a1dc-cfaab04ba2d9",
            "district": "L'arrondissement de Liège",
            "name": "Liège II",
            "address": {
              "street": "Rue de Bruxelles",
              "number": "2/0006",
              "postalCode": "4000",
              "city": "Liège"
            },
            "reportTemplates": null
          },
          {
            "id": "70a3be5e-4f21-4598-91fb-db94995e545b",
            "district": "L'arrondissement de Liège",
            "name": "Liège III",
            "address": {
              "street": "Rue de Bruxelles",
              "number": "2/0007",
              "postalCode": "4000",
              "city": "Liège"
            },
            "reportTemplates": null
          },
          {
            "id": "543c224c-26e8-4f1a-afec-4fff8ed553ea",
            "district": "L'arrondissement de Liège",
            "name": "Liège IV",
            "address": {
              "street": "Rue de Bruxelles",
              "number": "2/0005",
              "postalCode": "4000",
              "city": "Liège"
            },
            "reportTemplates": null
          },
          {
            "id": "f5c77a50-250f-49b9-9f26-27efecf1bf59",
            "district": "L'arrondissement de Liège",
            "name": "Seraing",
            "address": {
              "street": "Rue de l'Ecureuil",
              "number": "74",
              "postalCode": "4100",
              "city": "Seraing"
            },
            "reportTemplates": null
          },
          {
            "id": "00db60ae-50b4-4285-b515-16dc1a71f9dd",
            "district": "L'arrondissement de Liège",
            "name": "Spa",
            "address": {
              "street": "Avenue Reine Astrid",
              "number": "77a",
              "postalCode": "4900",
              "city": "Spa"
            },
            "reportTemplates": null
          },
          {
            "id": "11542590-77da-4a89-8947-f068c794390a",
            "district": "L'arrondissement de Liège",
            "name": "Sprimont",
            "address": {
              "street": "Rue du Pérréon",
              "number": "34",
              "postalCode": "4141",
              "city": "Louveigné"
            },
            "reportTemplates": null
          },
          {
            "id": "4028cfc1-2176-4a9c-9c63-b6a70705d1e3",
            "district": "L'arrondissement de Liège",
            "name": "Verviers I",
            "address": {
              "street": "Rue du Tribunal",
              "number": "9",
              "postalCode": "4800",
              "city": "Verviers"
            },
            "reportTemplates": null
          },
          {
            "id": "4e2b0393-bc26-4e83-8924-2f72bd241208",
            "district": "L'arrondissement de Liège",
            "name": "Verviers II",
            "address": {
              "street": "Rue du Tribunal",
              "number": "9",
              "postalCode": "4800",
              "city": "Verviers"
            },
            "reportTemplates": null
          },
          {
            "id": "3406d170-b217-44b2-8192-ad7fa0b3ff29",
            "district": "L'arrondissement de Liège",
            "name": "Visé",
            "address": {
              "street": "Place Jean Donnay",
              "number": "1",
              "postalCode": "4602",
              "city": "Cheratte"
            },
            "reportTemplates": null
          },
          {
            "id": "e1189ef4-f7a2-4128-a297-be51b9b1567d",
            "district": "L'arrondissement de Liège",
            "name": "Waremme",
            "address": {
              "street": "Avenue Emile Vandervelde",
              "number": "31 f",
              "postalCode": "4300",
              "city": "Waremme"
            },
            "reportTemplates": null
          },
          {
            "id": "bc4da19c-595c-4b31-a293-1fb6c8f256d7",
            "district": "L'arrondissement de Luxembourg",
            "name": "Arlon",
            "address": {
              "street": "Place Schalbert",
              "number": "A",
              "postalCode": "6700",
              "city": "Arlon"
            },
            "reportTemplates": null
          },
          {
            "id": "67d96436-e455-4bb6-8168-443242a537d2",
            "district": "L'arrondissement de Luxembourg",
            "name": "Bastogne",
            "address": {
              "street": "Rue des Récollets",
              "number": "6",
              "postalCode": "6600",
              "city": "Bastogne"
            },
            "reportTemplates": null
          },
          {
            "id": "26c8fad6-3836-4019-8b59-1c52d6ba8f31",
            "district": "L'arrondissement de Luxembourg",
            "name": "Marche-en-Famenne",
            "address": {
              "street": "Rue Victor Libert",
              "number": "7 - Batiment C",
              "postalCode": "6900",
              "city": "Marche-en-Famenne"
            },
            "reportTemplates": null
          },
          {
            "id": "17b9210f-145c-4e38-8d9a-836eecc16fc8",
            "district": "L'arrondissement de Luxembourg",
            "name": "Neufchâteau",
            "address": {
              "street": "Place Charles Bergh",
              "number": "7",
              "postalCode": "6840",
              "city": "Neufchâteau"
            },
            "reportTemplates": null
          },
          {
            "id": "7e38bbef-57e7-4e34-8027-c4f6744188fb",
            "district": "L'arrondissement de Luxembourg",
            "name": "Virton",
            "address": {
              "street": "Avenue Bouvier",
              "number": "27",
              "postalCode": "6760",
              "city": "Virton"
            },
            "reportTemplates": null
          },
          {
            "id": "2a107613-337a-42ae-929a-9390a84bfa5d",
            "district": "L'arrondissement de Namur",
            "name": "Andenne",
            "address": {
              "street": "Place du Perron",
              "number": "17",
              "postalCode": "5300",
              "city": "Andenne"
            },
            "reportTemplates": null
          },
          {
            "id": "833f19ff-a099-4b4f-8899-bd44da4497b1",
            "district": "L'arrondissement de Namur",
            "name": "Ciney",
            "address": {
              "street": "Rue Courtejoie",
              "number": "17",
              "postalCode": "5590",
              "city": "Ciney"
            },
            "reportTemplates": null
          },
          {
            "id": "4a55364d-70e7-470b-9c01-9529efc262f8",
            "district": "L'arrondissement de Namur",
            "name": "Dinant",
            "address": {
              "street": "Rue Arthur Defoin",
              "number": "215 A",
              "postalCode": "5500",
              "city": "Dinant"
            },
            "reportTemplates": null
          },
          {
            "id": "369bc869-fe23-4633-ab63-37fa0470fe08",
            "district": "L'arrondissement de Namur",
            "name": "Fosses-la-Ville",
            "address": {
              "street": "Rue Delmotte-Lemaître",
              "number": "6",
              "postalCode": "5070",
              "city": "Fosses-la-Ville"
            },
            "reportTemplates": null
          },
          {
            "id": "c085f9b9-8c53-4097-bf34-878bf768e5ab",
            "district": "L'arrondissement de Namur",
            "name": "Gembloux",
            "address": {
              "street": "Chaussée de Wavre",
              "number": "46",
              "postalCode": "5030",
              "city": "Gembloux"
            },
            "reportTemplates": null
          },
          {
            "id": "c0150531-a9e5-473d-b755-a33d47989da6",
            "district": "L'arrondissement de Namur",
            "name": "Namur I",
            "address": {
              "street": "Place Saint-Aubain",
              "number": "5",
              "postalCode": "5000",
              "city": "Namur"
            },
            "reportTemplates": null
          },
          {
            "id": "c2c3b553-9593-483c-b15f-6dff2369d2b2",
            "district": "L'arrondissement de Namur",
            "name": "Namur II",
            "address": {
              "street": "Rempart de la Vierge",
              "number": "2",
              "postalCode": "5000",
              "city": "Namur"
            },
            "reportTemplates": null
          },
          {
            "id": "19114be9-d2fa-4696-94a3-ba2ad71c1996",
            "district": "L'arrondissement de Namur",
            "name": "Philippeville - siège Couvin",
            "address": {
              "street": "Rue du Bercet",
              "number": "12",
              "postalCode": "5660",
              "city": "Couvin"
            },
            "reportTemplates": null
          },
          {
            "id": "aa0e3510-0a93-4136-822f-38cf7db65e98",
            "district": "L'arrondissement de Namur",
            "name": "Philippeville - siège Florennes",
            "address": {
              "street": "Rue de Mettet",
              "number": "21",
              "postalCode": "5620",
              "city": "Florennes"
            },
            "reportTemplates": null
          }
        ]
      }
    },
    {
      "endpoint": "^/maintenance-modes$",
      "response": {
        "status": 200,
        "body": {
          "global": false
        }
      }
    },
    {
      "endpoint": "^/notifications$",
      "response": {
        "status": 200,
        "body": {
          "content": [
            {
              "id": "e7b590e4-b16c-4c8b-b473-dfeca82a4c8f",
              "bankAccount": {
                "id": "1",
                "type": "BASE",
                "ownerType": "OFFICE",
                "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
                "label": "Aloic Abrim's base account",
                "iban": "BE41561146766410",
                "expiring": false,
                "status": "ACTIVE",
                "balance": 148.45,
                "currency": "EUR",
                "position": 1,
                "financialInstitutionName": "BNP Paribas Fortis",
                "supportPayments": false
              },
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION"
                ],
                "municipality": "Aarschot"
              },
              "dateCreated": "2024-04-30",
              "closed": false,
              "closedBySystem": false,
              "title": "Nieuwe inkomsten gedetecteerd",
              "description": "Nieuwe inkomsten gedetecteerd: ± € 50,00 op 29/04/2024",
              "details": null,
              "subNotifications": [
                {
                  "dateCreated": "2024-05-16",
                  "description": "Manueel afgesloten door Jack De Ripper"
                },
                {
                  "dateCreated": "2024-05-17",
                  "description": "Manueel heropend door Jack De Ripper"
                }
              ],
              "document": null
            },
            {
              "id": "e9791555-e22d-4302-95b1-54d4fac87fa5",
              "bankAccount": {
                "id": "1",
                "type": "BASE",
                "ownerType": "OFFICE",
                "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
                "label": "Aloic Abrim's base account",
                "iban": "BE41561146766410",
                "expiring": false,
                "status": "ACTIVE",
                "balance": 148.45,
                "currency": "EUR",
                "position": 1,
                "financialInstitutionName": "BNP Paribas Fortis",
                "supportPayments": false
              },
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION"
                ],
                "municipality": "Aarschot"
              },
              "dateCreated": "2024-04-11",
              "closed": true,
              "closedBySystem": true,
              "title": "Verwachte betaling ontbreekt",
              "description": "Er werd een betaling van ± € -500,16 aan Woonpartners verwacht op 01/04/2024, maar deze werd niet gedetecteerd.",
              "details": "Details van de verwachte verrichting:<br>- Bedrag: ± € -500,16<br>- Datum: 01/04/2024<br>- Naam tegenpartij: Woonpartners<br>- Referentie tegenpartij: BE72 5495 9383 4216<br>- Mededeling: -<br>- Omschrijving: overschrijving",
              "document": null,
              "subNotifications": []
            },
            {
              "id": "4b219fd9-d245-4bd3-9012-f03f2ccd9fd6",
              "bankAccount": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION"
                ],
                "municipality": "Aarschot"
              },
              "dateCreated": "2023-06-29",
              "closed": false,
              "closedBySystem": false,
              "title": "Eindrapport moet ingediend worden",
              "description": "Tegen 29/07/2023 moet het eindverslag schuldbemiddeling ingediend worden bij Arbeidsrechtbank Gent.",
              "details": null,
              "subNotifications": [],
              "document": null
            },
            {
              "id": "373207a6-b1e6-4d97-9d20-b494c78f477d",
              "bankAccount": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION"
                ],
                "municipality": "Aarschot"
              },
              "dateCreated": "2023-04-14",
              "closed": false,
              "closedBySystem": false,
              "title": "Aanvraag om te betalen",
              "description": "Client heeft gevraagd om deze factuur te betalen",
              "details": null,
              "subNotifications": [],
              "document": {
                "id": "30688aa8-7f0f-47f9-a7b0-953f20bdae69",
                "name": "factuur.pdf",
                "shareResponse": null
              }
            },
            {
              "id": "8791f883-9a07-458e-9b19-7202a0158d40",
              "bankAccount": {
                "id": "c3edef94-4cf7-47d9-9e6f-ed5236dca530",
                "type": "BASE",
                "ownerType": "CLIENT",
                "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
                "label": "Bernard Boudoucx's private bank account",
                "iban": "BE86519834538350",
                "expiring": false,
                "expiresAt": "2024-08-22T08:59:37.594",
                "status": "ACTIVE",
                "balance": 2022.09,
                "currency": "EUR",
                "position": 1,
                "financialInstitutionName": "BNP Paribas Fortis",
                "supportPayments": false
              },
              "client": {
                "id": "2",
                "firstName": "Bernard",
                "lastName": "Bodoucx",
                "type": "FINANCIAL_MANAGEMENT",
                "types": [
                  "FINANCIAL_MANAGEMENT"
                ],
                "municipality": "Brugge"
              },
              "dateCreated": "2024-05-24",
              "closed": true,
              "closedBySystem": false,
              "title": "Ontoereikend saldo verwacht",
              "description": "Ontoereikend saldo verwacht op 24/05/2024, momenteel is het saldo € 2.022,09",
              "details": null,
              "subNotifications": [],
              "document": null
            }
          ],
          "totalElements": 5,
          "size": 20,
          "number": 0
        }
      }
    },
    {
      "endpoint": "^/offices/[^/]+$",
      "response": {
        "status": 200,
        "body": {
          "name": "De advocaten",
          "clientTypes": [
            "DEBT_MEDIATION",
            "FINANCIAL_MANAGEMENT",
            "SOCIAL_RENT",
            "BUDGET_GUIDANCE",
            "RENT",
            "PCSW"
          ],
          "dummy": false,
          "features": [
            "ISABEL_AIS",
            "ISABEL_PI",
            "XS2A"
          ],
          "allowImportXs2a": true,
          "language": "nl",
          "address": {
            "street": "Zwijnaardsesteenweg",
            "number": "772",
            "postalCode": "9000",
            "city": "Gent"
          },
          "ibans": [
            "BE60897933818270",
            "BE82817158678268"
          ],
          "defaultJusticePeace": {
            "id": "3ecbfb5b-0f4e-44a7-88b2-43ab67821efe",
            "district": "Arrondissement Oost-Vlaanderen",
            "name": "Gent 1"
          },
          "defaultLabourCourt": {
            "id": "b11ba668-fef8-40b5-a9ed-158536500273",
            "name": "Arbeidsrechtbank Gent",
            "department": "afdeling Gent"
          }
        }
      }
    },
    {
      "endpoint": "^/offices/[^/]+/beneficiaries$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": "f3817e5f-884f-4406-b6e9-3c286e21eeba",
            "global": true,
            "counterpartName": "FOD Financien",
            "counterpartReference": "BE76978387366795",
            "type": "BENEFICIARY"
          }
        ]
      }
    },
    {
      "endpoint": "^/offices/[^/]+/logo$",
      "response": {
        "status": 200
      }
    },
    {
      "endpoint": "^/payment-accounts$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": "3",
            "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
            "label": "Aloic Abrim's security account",
            "iban": "BE93561683715667",
            "balance": 125.36,
            "currency": "EUR",
            "clientId": "1",
            "type": "BASE",
            "position": 1,
            "ownerType": "OFFICE "
          },
          {
            "id": "6",
            "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
            "label": "Doulehan Dracovich's office bank account",
            "iban": "BE81343377238700",
            "balance": -12001.93,
            "currency": "EUR",
            "clientId": 4,
            "type": "SAVINGS",
            "position": 1,
            "ownerType": "OFFICE "
          },
          {
            "id": "8",
            "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
            "label": "Eloise Elenthal's office bank account",
            "iban": "BE81343377238700",
            "balance": 101.93,
            "currency": "EUR",
            "clientId": "5",
            "type": "BASE",
            "position": 1,
            "ownerType": "OFFICE "
          },
          {
            "id": "10",
            "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/beobank.svg",
            "label": "Häelghor Häelghor's local bank account",
            "iban": "BE13679194762770",
            "balance": 1589.12,
            "currency": "EUR",
            "clientId": "8",
            "type": "RESERVE",
            "position": 1,
            "ownerType": "OFFICE "
          }
        ]
      }
    },
    {
      "endpoint": "^/payments$",
      "response": {
        "status": 200,
        "body": {
          "content": [
            {
              "id": "1",
              "status": "NOT_SUBMITTED",
              "amount": 20,
              "counterpartName": "Basisrekening",
              "counterpartReference": "BE38233422281672",
              "remittanceInformationType": "UNSTRUCTURED",
              "remittanceInformation": "Test KPI",
              "executionDate": "2024-10-01",
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              },
              "bankAccount": {
                "id": "1",
                "type": "BASE",
                "ownerType": "OFFICE",
                "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
                "label": "Aloic Abrim's bank account",
                "iban": "BE41561146766410",
                "expiring": false,
                "status": "ACTIVE",
                "balance": 458.96,
                "currency": "EUR",
                "position": 1,
                "financialInstitutionName": "BNP Paribas Fortis",
                "supportPayments": true
              }
            },
            {
              "id": "2",
              "status": "NOT_SUBMITTED",
              "amount": 59,
              "counterpartName": "Proximus",
              "counterpartReference": "BE02663366543140",
              "remittanceInformationType": "UNSTRUCTURED",
              "remittanceInformation": "Leefgeld",
              "executionDate": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              },
              "bankAccount": {
                "id": "1",
                "type": "BASE",
                "ownerType": "OFFICE",
                "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
                "label": "Aloic Abrim's bank account",
                "iban": "BE41561146766410",
                "expiring": false,
                "status": "ACTIVE",
                "balance": 458.96,
                "currency": "EUR",
                "position": 1,
                "financialInstitutionName": "BNP Paribas Fortis",
                "supportPayments": true
              }
            },
            {
              "id": "3",
              "status": "NOT_SUBMITTED",
              "amount": 15,
              "counterpartName": "Danielle Aufderhar",
              "counterpartReference": "BE70901862236707",
              "remittanceInformationType": "UNSTRUCTURED",
              "remittanceInformation": "12566",
              "executionDate": null,
              "client": {
                "id": "2",
                "firstName": "Bernard",
                "lastName": "Bodoucx",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION"
                ],
                "municipality": "Brugge"
              },
              "bankAccount": {
                "ownerType": "OFFICE",
                "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
                "label": "Bernard Boudoucx's private bank account",
                "iban": "BE86519834538350",
                "expiring": false,
                "status": "ACTIVE",
                "balance": -43.98,
                "currency": "EUR",
                "financialInstitutionName": "BNP Paribas Fortis",
                "supportPayments": false
              }
            },
            {
              "id": "4",
              "status": "PROCESSED_OK",
              "amount": 1,
              "counterpartName": "Basisrekening",
              "counterpartReference": "BE35978191265737",
              "remittanceInformationType": "UNSTRUCTURED",
              "remittanceInformation": "Test",
              "executionDate": "2023-12-21",
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              },
              "bankAccount": {
                "id": "3",
                "type": "BASE",
                "ownerType": "OFFICE",
                "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
                "label": "Aloic Abrim's bank account",
                "iban": "BE41561146766410",
                "expiring": false,
                "status": "ACTIVE",
                "balance": 458.96,
                "currency": "EUR",
                "position": 1,
                "financialInstitutionName": "BNP Paribas Fortis",
                "supportPayments": true
              }
            }
          ],
          "totalElements": 4,
          "size": 20,
          "number": 0
        }
      }
    },
    {
      "endpoint": "^/profile$",
      "response": {
        "status": 200,
        "body": {
          "id": "1",
          "firstName": "Mocky",
          "lastName": "Balboa",
          "email": "mocky@balboa.com",
          "language": "nl",
          "officeId": "1234",
          "roles": [
            "OFFICE_USER",
            "OFFICE_SUPERVISOR",
            "OFFICE_ADMIN"
          ],
          "invitationPending": false
        }
      }
    },
    {
      "endpoint": "^/settings$",
      "response": {
        "status": 200,
        "body": {}
      }
    },
    {
      "endpoint": "^/simple-clients$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": "1",
            "firstName": "Aloic",
            "lastName": "Abrim",
            "municipality": "Aarschot",
            "type": "DEBT_MEDIATION",
            "types": [
              "DEBT_MEDIATION",
              "FINANCIAL_MANAGEMENT",
              "BUDGET_GUIDANCE"
            ]
          },
          {
            "id": "2",
            "firstName": "Bernard",
            "lastName": "Bodoucx",
            "municipality": "Brugge",
            "type": "FINANCIAL_MANAGEMENT",
            "types": [
              "FINANCIAL_MANAGEMENT"
            ]
          },
          {
            "id": "3",
            "firstName": "Cedric",
            "lastName": "Crudelac",
            "municipality": "Cardif",
            "type": "SOCIAL_RENT",
            "types": [
              "SOCIAL_RENT"
            ]
          },
          {
            "id": "4",
            "firstName": "Doulehan",
            "lastName": "Dracovich",
            "municipality": null,
            "type": "BUDGET_GUIDANCE",
            "types": [
              "BUDGET_GUIDANCE"
            ]
          },
          {
            "id": "5",
            "firstName": "Eloise",
            "lastName": "Elenthal",
            "municipality": null,
            "type": "RENT",
            "types": [
              "RENT"
            ]
          },
          {
            "id": "6",
            "firstName": "Fainor",
            "lastName": "Falenthir",
            "municipality": "",
            "type": "PCSW",
            "types": [
              "PCSW"
            ]
          },
          {
            "id": "7",
            "firstName": "Gregory",
            "lastName": "Grohe",
            "municipality": "Gent",
            "type": "RENT",
            "types": [
              "RENT"
            ]
          },
          {
            "id": "8",
            "firstName": "Häelghor",
            "lastName": "Häelghor",
            "type": "PCSW",
            "types": [
              "PCSW",
              "RENT"
            ]
          },
          {
            "id": "9",
            "firstName": "Ilya",
            "lastName": "Incoreva",
            "municipality": "Izegem",
            "type": "DEBT_MEDIATION",
            "types": [
              "DEBT_MEDIATION"
            ]
          },
          {
            "id": "10",
            "firstName": "Jelena",
            "lastName": "Jacorolich",
            "municipality": "",
            "type": "DEBT_MEDIATION",
            "types": [
              "DEBT_MEDIATION"
            ]
          },
          {
            "id": "11",
            "firstName": "Khalid",
            "lastName": "Kumar",
            "municipality": null,
            "type": "PCSW",
            "types": [
              "PCSW"
            ]
          },
          {
            "id": "12",
            "firstName": "Lemur",
            "lastName": "Lovondich",
            "municipality": "",
            "type": "RENT",
            "types": [
              "RENT"
            ]
          },
          {
            "id": "13",
            "firstName": "Mehral",
            "lastName": "Mundil",
            "municipality": "",
            "type": "BUDGET_GUIDANCE",
            "types": [
              "BUDGET_GUIDANCE"
            ]
          },
          {
            "id": "14",
            "firstName": "Nidar",
            "lastName": "Nuluccu",
            "municipality": "",
            "type": "FINANCIAL_MANAGEMENT",
            "types": [
              "FINANCIAL_MANAGEMENT"
            ]
          },
          {
            "id": "15",
            "firstName": "Orphe",
            "lastName": "Oolo",
            "municipality": "",
            "type": "RENT",
            "types": [
              "RENT"
            ]
          },
          {
            "id": "16",
            "firstName": "Pendar",
            "lastName": "Pudalic",
            "municipality": "",
            "type": "FINANCIAL_MANAGEMENT",
            "types": [
              "FINANCIAL_MANAGEMENT"
            ]
          }
        ]
      }
    },
    {
      "endpoint": "^/simple-users$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": "76f33a7d-c863-407a-88e8-e5c89ecb80e6",
            "firstName": "Patricia",
            "lastName": "De Koekelaere"
          },
          {
            "id": "064c31bf-c0a7-4893-8c98-0e9ee385a0f6",
            "firstName": "Jack",
            "lastName": "De Ripper"
          },
          {
            "id": "a5283a8e-ecad-4518-9836-0fe3a1511d58",
            "firstName": "Lorenzo",
            "lastName": "Del m'Ertens"
          },
          {
            "id": "30c49e66-1d0c-4de6-94a8-798e2ea32163",
            "firstName": "Matty",
            "lastName": "Dive"
          }
        ]
      }
    },
    {
      "endpoint": "^/transaction-categories$",
      "response": {
        "status": 200,
        "body": [
          {
            "mainCategoryName": "income",
            "subCategoryName": "employment",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Inkomen uit arbeid",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "pension",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Pensioenen",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "benefits-unemployment",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Werkloosheidsuitkering",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "benefits-sickness",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Uitkering ziekenfonds",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "child-support-personal",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Kinderbijslag (persoonlijk)",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "child-support-children",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Kinderbijslag (kinderen)",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "alimony-personal",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Onderhoudsgeld (persoonlijk)",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "alimony-children",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Onderhoudsgeld (kinderen)",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "benefits-handicap",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Tegemoetkoming aan personen met een handicap",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "benefits-social",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Sociale toelagen",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "interests",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Interesten",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "rent-income",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Huur- en pachtgelden",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "investments",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Meerwaarde op beleggingen",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "reimbursements-health-insurance",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Terugbetaling ziekenfonds",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "tax-refund",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Terugbetaling belastingen",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "reimbursements",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Terugbetalingen (andere)",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "donations-gifts-income",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Schenkingen / giften",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "inheritance",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Nalatenschappen",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "income-other",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Inkomsten (andere)",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "test",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Test",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "test-2",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "Test 2",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "income",
            "subCategoryName": "incoming-transfer",
            "mainCategoryLabel": "Inkomsten",
            "subCategoryLabel": "incoming transfer",
            "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "living",
            "subCategoryName": "rent",
            "mainCategoryLabel": "Wonen",
            "subCategoryLabel": "Huur",
            "icon": "https://app-dev.roov.app/assets/icons/house-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "living",
            "subCategoryName": "mortgage",
            "mainCategoryLabel": "Wonen",
            "subCategoryLabel": "Hypotheek",
            "icon": "https://app-dev.roov.app/assets/icons/house-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "living",
            "subCategoryName": "residence-institution",
            "mainCategoryLabel": "Wonen",
            "subCategoryLabel": "Woonzorgcentrum / instelling",
            "icon": "https://app-dev.roov.app/assets/icons/house-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "living",
            "subCategoryName": "property-tax",
            "mainCategoryLabel": "Wonen",
            "subCategoryLabel": "Onroerende voorheffing",
            "icon": "https://app-dev.roov.app/assets/icons/house-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "living",
            "subCategoryName": "maintenance-repairs",
            "mainCategoryLabel": "Wonen",
            "subCategoryLabel": "Onderhoud / herstellingen",
            "icon": "https://app-dev.roov.app/assets/icons/house-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "living",
            "subCategoryName": "home-liability-insurance",
            "mainCategoryLabel": "Wonen",
            "subCategoryLabel": "Brandverzekering en BA",
            "icon": "https://app-dev.roov.app/assets/icons/house-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "living",
            "subCategoryName": "credit-insurance",
            "mainCategoryLabel": "Wonen",
            "subCategoryLabel": "Schuldsaldoverzekering",
            "icon": "https://app-dev.roov.app/assets/icons/house-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "living",
            "subCategoryName": "living-other",
            "mainCategoryLabel": "Wonen",
            "subCategoryLabel": "Wonen (andere)",
            "icon": "https://app-dev.roov.app/assets/icons/house-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "living",
            "subCategoryName": "huisje",
            "mainCategoryLabel": "Wonen",
            "subCategoryLabel": "huisje",
            "icon": "https://app-dev.roov.app/assets/icons/house-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "utilities",
            "subCategoryName": "electricity",
            "mainCategoryLabel": "Nutsvoorzieningen",
            "subCategoryLabel": "Elektriciteit",
            "icon": "https://app-dev.roov.app/assets/icons/plug-circle-bolt-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "utilities",
            "subCategoryName": "heating",
            "mainCategoryLabel": "Nutsvoorzieningen",
            "subCategoryLabel": "Verwarming",
            "icon": "https://app-dev.roov.app/assets/icons/plug-circle-bolt-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "utilities",
            "subCategoryName": "water",
            "mainCategoryLabel": "Nutsvoorzieningen",
            "subCategoryLabel": "Water",
            "icon": "https://app-dev.roov.app/assets/icons/plug-circle-bolt-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "utilities",
            "subCategoryName": "tv-internet",
            "mainCategoryLabel": "Nutsvoorzieningen",
            "subCategoryLabel": "TV / Internet",
            "icon": "https://app-dev.roov.app/assets/icons/plug-circle-bolt-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "utilities",
            "subCategoryName": "mobile-telephone",
            "mainCategoryLabel": "Nutsvoorzieningen",
            "subCategoryLabel": "GSM / telefoon",
            "icon": "https://app-dev.roov.app/assets/icons/plug-circle-bolt-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "utilities",
            "subCategoryName": "utilities-other",
            "mainCategoryLabel": "Nutsvoorzieningen",
            "subCategoryLabel": "Nutsvoorzieningen (andere)",
            "icon": "https://app-dev.roov.app/assets/icons/plug-circle-bolt-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "utilities",
            "subCategoryName": "proximus",
            "mainCategoryLabel": "Nutsvoorzieningen",
            "subCategoryLabel": "proximus",
            "icon": "https://app-dev.roov.app/assets/icons/plug-circle-bolt-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "utilities",
            "subCategoryName": "nujchuhur uegudgygydagyue yttydftftftdf tydftrredt ftrefdetbd gtygerygy",
            "mainCategoryLabel": "Nutsvoorzieningen",
            "subCategoryLabel": "nujchuhur uegudgygydagyue yttydftftftdf tydftrredt ftrefdetbd gtygerygy",
            "icon": "https://app-dev.roov.app/assets/icons/plug-circle-bolt-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "mobility",
            "subCategoryName": "car-insurance",
            "mainCategoryLabel": "Mobiliteit",
            "subCategoryLabel": "Autoverzekering",
            "icon": "https://app-dev.roov.app/assets/icons/person-biking-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "mobility",
            "subCategoryName": "road-tax",
            "mainCategoryLabel": "Mobiliteit",
            "subCategoryLabel": "Verkeersbelasting",
            "icon": "https://app-dev.roov.app/assets/icons/person-biking-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "mobility",
            "subCategoryName": "maintenance",
            "mainCategoryLabel": "Mobiliteit",
            "subCategoryLabel": "Onderhoud",
            "icon": "https://app-dev.roov.app/assets/icons/person-biking-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "mobility",
            "subCategoryName": "fuel",
            "mainCategoryLabel": "Mobiliteit",
            "subCategoryLabel": "Brandstof",
            "icon": "https://app-dev.roov.app/assets/icons/person-biking-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "mobility",
            "subCategoryName": "mobility-other",
            "mainCategoryLabel": "Mobiliteit",
            "subCategoryLabel": "Mobiliteit (andere)",
            "icon": "https://app-dev.roov.app/assets/icons/person-biking-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "mobility",
            "subCategoryName": "auto-opladen",
            "mainCategoryLabel": "Mobiliteit",
            "subCategoryLabel": "auto opladen",
            "icon": "https://app-dev.roov.app/assets/icons/person-biking-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "fiscal",
            "subCategoryName": "province-tax",
            "mainCategoryLabel": "Fiscaliteit",
            "subCategoryLabel": "Provinciebelasting",
            "icon": "https://app-dev.roov.app/assets/icons/landmark-flag-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "fiscal",
            "subCategoryName": "municipal-tax",
            "mainCategoryLabel": "Fiscaliteit",
            "subCategoryLabel": "Gemeentebelasting",
            "icon": "https://app-dev.roov.app/assets/icons/landmark-flag-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "fiscal",
            "subCategoryName": "personal-tax",
            "mainCategoryLabel": "Fiscaliteit",
            "subCategoryLabel": "Personenbelasting",
            "icon": "https://app-dev.roov.app/assets/icons/landmark-flag-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "fiscal",
            "subCategoryName": "fiscal-other",
            "mainCategoryLabel": "Fiscaliteit",
            "subCategoryLabel": "Fiscaliteit (andere)",
            "icon": "https://app-dev.roov.app/assets/icons/landmark-flag-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "fiscal",
            "subCategoryName": "belastingen",
            "mainCategoryLabel": "Fiscaliteit",
            "subCategoryLabel": "belastingen",
            "icon": "https://app-dev.roov.app/assets/icons/landmark-flag-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "health",
            "subCategoryName": "medical-fixed",
            "mainCategoryLabel": "Gezondheid",
            "subCategoryLabel": "Medische en paramedische kosten en medicatie (vast)",
            "icon": "https://app-dev.roov.app/assets/icons/heart-pulse-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "health",
            "subCategoryName": "medical-exceptional",
            "mainCategoryLabel": "Gezondheid",
            "subCategoryLabel": "Medische en paramedische kosten en medicatie (uitzonderlijk)",
            "icon": "https://app-dev.roov.app/assets/icons/heart-pulse-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "health",
            "subCategoryName": "hospitalisation-insurance",
            "mainCategoryLabel": "Gezondheid",
            "subCategoryLabel": "Hospitalisatieverzekering",
            "icon": "https://app-dev.roov.app/assets/icons/heart-pulse-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "health",
            "subCategoryName": "health-insurance",
            "mainCategoryLabel": "Gezondheid",
            "subCategoryLabel": "Ziekenfonds",
            "icon": "https://app-dev.roov.app/assets/icons/heart-pulse-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "health",
            "subCategoryName": "health-other",
            "mainCategoryLabel": "Gezondheid",
            "subCategoryLabel": "Gezondheid (andere)",
            "icon": "https://app-dev.roov.app/assets/icons/heart-pulse-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "health",
            "subCategoryName": "apotheek",
            "mainCategoryLabel": "Gezondheid",
            "subCategoryLabel": "apotheek",
            "icon": "https://app-dev.roov.app/assets/icons/heart-pulse-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "personal",
            "subCategoryName": "allowance-guardianship",
            "mainCategoryLabel": "Persoonlijk",
            "subCategoryLabel": "Bedragen door bewindvoerder ter beschikking gesteld van de beschermde persoon",
            "icon": "https://app-dev.roov.app/assets/icons/user-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "personal",
            "subCategoryName": "allowance-mediation",
            "mainCategoryLabel": "Persoonlijk",
            "subCategoryLabel": "Leefgeld",
            "icon": "https://app-dev.roov.app/assets/icons/user-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "personal",
            "subCategoryName": "union",
            "mainCategoryLabel": "Persoonlijk",
            "subCategoryLabel": "Vakbondsbijdrage",
            "icon": "https://app-dev.roov.app/assets/icons/user-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "personal",
            "subCategoryName": "alimony",
            "mainCategoryLabel": "Persoonlijk",
            "subCategoryLabel": "Onderhoudsbijdragen",
            "icon": "https://app-dev.roov.app/assets/icons/user-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "personal",
            "subCategoryName": "school-daycare",
            "mainCategoryLabel": "Persoonlijk",
            "subCategoryLabel": "School / opvang",
            "icon": "https://app-dev.roov.app/assets/icons/user-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "personal",
            "subCategoryName": "children-other",
            "mainCategoryLabel": "Persoonlijk",
            "subCategoryLabel": "Kinderen (andere)",
            "icon": "https://app-dev.roov.app/assets/icons/user-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "personal",
            "subCategoryName": "loans",
            "mainCategoryLabel": "Persoonlijk",
            "subCategoryLabel": "Leningen",
            "icon": "https://app-dev.roov.app/assets/icons/user-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "personal",
            "subCategoryName": "donations-gifts",
            "mainCategoryLabel": "Persoonlijk",
            "subCategoryLabel": "Schenkingen / giften",
            "icon": "https://app-dev.roov.app/assets/icons/user-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "personal",
            "subCategoryName": "retirement-savings",
            "mainCategoryLabel": "Persoonlijk",
            "subCategoryLabel": "Pensioensparen",
            "icon": "https://app-dev.roov.app/assets/icons/user-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "personal",
            "subCategoryName": "insurances",
            "mainCategoryLabel": "Persoonlijk",
            "subCategoryLabel": "Verzekeringen",
            "icon": "https://app-dev.roov.app/assets/icons/user-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "personal",
            "subCategoryName": "personal-other",
            "mainCategoryLabel": "Persoonlijk",
            "subCategoryLabel": "Persoonlijk (andere)",
            "icon": "https://app-dev.roov.app/assets/icons/user-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "personal",
            "subCategoryName": "debt-repayment",
            "mainCategoryLabel": "Persoonlijk",
            "subCategoryLabel": "Afbetaling schulden (niet CSR)",
            "icon": "https://app-dev.roov.app/assets/icons/user-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "personal",
            "subCategoryName": "test",
            "mainCategoryLabel": "Persoonlijk",
            "subCategoryLabel": "Test",
            "icon": "https://app-dev.roov.app/assets/icons/user-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "file",
            "subCategoryName": "guardianship",
            "mainCategoryLabel": "Dossier",
            "subCategoryLabel": "Beheersvergoeding bewindvoerder",
            "icon": "https://app-dev.roov.app/assets/icons/folder-closed-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "file",
            "subCategoryName": "debt-mediation",
            "mainCategoryLabel": "Dossier",
            "subCategoryLabel": "Kosten procedure CSR",
            "icon": "https://app-dev.roov.app/assets/icons/folder-closed-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "file",
            "subCategoryName": "debt-repayment",
            "mainCategoryLabel": "Dossier",
            "subCategoryLabel": "Afbetaling schulden (CSR)",
            "icon": "https://app-dev.roov.app/assets/icons/folder-closed-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": true
          },
          {
            "mainCategoryName": "file",
            "subCategoryName": "dossier-eigen",
            "mainCategoryLabel": "Dossier",
            "subCategoryLabel": "dossier eigen",
            "icon": "https://app-dev.roov.app/assets/icons/folder-closed-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "other",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "Andere",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "ice cream",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "ice cream",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "test",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "test",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "test2",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "test2",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "test3",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "test3",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "ajout",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "Ajout",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "new-category",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "New category",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "toet",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "toet",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "de-beste-categorie-ooit-gemaakt",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "De beste categorie ooit gemaakt",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "iets-volledig-anders",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "iets volledig anders",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "kapper",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "Kapper",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "howla",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "howla",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "test4",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "test4",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "other",
            "subCategoryName": "special",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "special <&>",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "DEBIT",
            "debtRepayment": false
          },
          {
            "mainCategoryName": "transfers",
            "subCategoryName": "transfers",
            "mainCategoryLabel": "Transfers",
            "subCategoryLabel": "Transfers",
            "icon": null,
            "creditor": null,
            "type": null,
            "debtRepayment": false
          },
          {
            "mainCategoryName": "transfers",
            "subCategoryName": "incoming-transfer",
            "mainCategoryLabel": "Transfers",
            "subCategoryLabel": "incoming transfer",
            "icon": null,
            "creditor": null,
            "type": null,
            "debtRepayment": false
          },
          {
            "mainCategoryName": "transfers",
            "subCategoryName": "test",
            "mainCategoryLabel": "Transfers",
            "subCategoryLabel": "test",
            "icon": null,
            "creditor": null,
            "type": null,
            "debtRepayment": false
          }
        ]
      }
    },
    {
      "endpoint": "^/users$",
      "response": {
        "status": 200,
        "body": {
          "content": [
            {
              "id": "76f33a7d-c863-407a-88e8-e5c89ecb80e6",
              "firstName": "Patricia",
              "lastName": "De Koekelaere",
              "email": "patricia@roov.app",
              "blocked": false,
              "invitationPending": false,
              "role": "OFFICE_SUPERVISOR",
              "defaultAdministrator": false,
              "defaultDebtMediator": false
            },
            {
              "id": "064c31bf-c0a7-4893-8c98-0e9ee385a0f6",
              "firstName": "Jack",
              "lastName": "De Ripper",
              "email": "jack@roov.app",
              "blocked": false,
              "invitationPending": false,
              "role": "OFFICE_ADMIN",
              "defaultAdministrator": true,
              "defaultDebtMediator": false
            },
            {
              "id": "a5283a8e-ecad-4518-9836-0fe3a1511d58",
              "firstName": "Lorenzo",
              "lastName": "Del m'Ertens",
              "email": "lorenzo@roov.app",
              "blocked": true,
              "invitationPending": false,
              "role": "OFFICE_SUPERVISOR",
              "defaultAdministrator": false,
              "defaultDebtMediator": false
            },
            {
              "id": "30c49e66-1d0c-4de6-94a8-798e2ea32163",
              "firstName": "Matty",
              "lastName": "Dive",
              "email": "matty@roov.app",
              "blocked": false,
              "invitationPending": true,
              "role": "OFFICE_ADMIN",
              "defaultAdministrator": false,
              "defaultDebtMediator": true
            }
          ],
          "totalElements": 4,
          "size": 20,
          "number": 0
        }
      }
    },
    {
      "endpoint": "^/xs2a-financial-institutions$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": "abn_amro",
            "name": "ABN-AMRO",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/abn_amro.svg",
            "acquiredBy": null,
            "bic": "ABNANL2A",
            "authorizationModel": "single"
          },
          {
            "id": "argenta",
            "name": "Argenta",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/argenta.svg",
            "acquiredBy": null,
            "bic": "ARSPBE22",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "van_breda",
            "name": "Bank J. Van Breda & C°",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/van_breda.svg",
            "acquiredBy": null,
            "bic": "JVBABE22",
            "authorizationModel": "detailed"
          },
          {
            "id": "belfius",
            "name": "Belfius",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/belfius.svg",
            "acquiredBy": null,
            "bic": "GKCCBEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "beobank",
            "name": "Beobank",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/beobank.svg",
            "acquiredBy": null,
            "bic": "CTBKBEBX",
            "authorizationModel": "global"
          },
          {
            "id": "bnp",
            "name": "BNP Paribas Fortis",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
            "acquiredBy": null,
            "bic": "GEBABEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "bnp_business",
            "name": "BNP Paribas Fortis Business",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
            "acquiredBy": null,
            "bic": "GEBABEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "cbc",
            "name": "CBC",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/cbc.svg",
            "acquiredBy": null,
            "bic": "CREGBEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "crelan",
            "name": "Crelan",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/crelan.svg",
            "acquiredBy": null,
            "bic": "NICABEBB",
            "authorizationModel": "detailed"
          },
          {
            "id": "deutsche_bank",
            "name": "Deutsche Bank",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/deutsche_bank.svg",
            "acquiredBy": null,
            "bic": "DEUTBEBE",
            "authorizationModel": "detailed"
          },
          {
            "id": "europabank",
            "name": "Europabank",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/europabank.svg",
            "acquiredBy": null,
            "bic": "EURBBE99",
            "authorizationModel": "detailed"
          },
          {
            "id": "fintro",
            "name": "Fintro",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/fintro.svg",
            "acquiredBy": null,
            "bic": "GEBABEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "hello_bank",
            "name": "Hello bank!",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/hello_bank.svg",
            "acquiredBy": null,
            "bic": "GEBABEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "ing",
            "name": "ING",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/ing.svg",
            "acquiredBy": null,
            "bic": "BBRUBEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "kbc",
            "name": "KBC",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/kbc.svg",
            "acquiredBy": null,
            "bic": "KREDBEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "kbc_brussels",
            "name": "KBC Brussels",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/kbc_brussels.svg",
            "acquiredBy": null,
            "bic": "KREDBEBB",
            "authorizationModel": "financialInstitutionOffered"
          },
          {
            "id": "keytrade",
            "name": "Keytrade",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/keytrade.svg",
            "acquiredBy": null,
            "bic": "KEYTBEBB",
            "authorizationModel": "detailed"
          },
          {
            "id": "nagelmackers",
            "name": "Nagelmackers",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/nagelmackers.svg",
            "acquiredBy": null,
            "bic": "BNAGBEBB",
            "authorizationModel": "detailed"
          },
          {
            "id": "vdk",
            "name": "VDK",
            "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/vdk.svg",
            "acquiredBy": null,
            "bic": "VDSPBE91",
            "authorizationModel": "detailed"
          }
        ]
      }
    },
    {
      "endpoint": "^/xs2a-financial-institutions/[^/]+$",
      "response": {
        "status": 200,
        "body": {
          "id": "europabank",
          "name": "Europabank",
          "logo": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/europabank.svg",
          "acquiredBy": null,
          "bic": "EURBBE99",
          "authorizationModel": "detailed"
        }
      }
    },
    {
      "endpoint": "^/xs2a-financial-institutions/[^/]+/aiar-info$",
      "response": {
        "status": 200,
        "body": {
          "customerReferenceRequired": true,
          "activeBankAccounts": [
            {
              "iban": "BE08735946344213",
              "type": "BASE"
            },
            {
              "iban": "BE51548224237662",
              "type": "VAPH"
            },
            {
              "iban": "BE84549579744459",
              "type": "ALLOWANCE"
            }
          ],
          "isabelBankAccounts": [
            {
              "iban": "BE93561683715667",
              "type": "BASE"
            },
            {
              "iban": "BE39549169934819",
              "type": "VAPH"
            },
            {
              "iban": "BE39519293265519",
              "type": "ALLOWANCE"
            }
          ]
        }
      }
    }
  ],
  "put": [
    {
      "endpoint": "^/auth0-user-id$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/bank-accounts/[^/]+/client-settings$",
      "response": {
        "status": 200,
        "body": {
          "clientId": "1",
          "type": "BASE",
          "showIncomingTransactions": true,
          "showOutgoingTransactions": true,
          "showBalance": true
        }
      }
    },
    {
      "endpoint": "^/bank-accounts/[^/]+/label$",
      "response": {
        "status": 200,
        "body": "Aloic Abrim's account"
      }
    },
    {
      "endpoint": "^/bank-accounts/[^/]+/transactions/[^/]+/categories/office",
      "response": {
        "status": 200,
        "body": {
        }
      }
    },
    {
      "endpoint": "^/bank-accounts/[^/]+/transactions/[^/]+/tags",
      "response": {
        "status": 200,
        "body": {
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/bank-accounts$",
      "response": {
        "status": 200,
        "body": {
          "officeAccounts": [
            {
              "position": 1,
              "type": "ALLOWANCE",
              "iban": "BE48735214218727",
              "linked": false
            },
            {
              "position": 2,
              "type": "SECURITY",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "financialInstitutionName": "BNP Parisbas",
              "label": "Aloic Abrim's security account",
              "iban": "BE93561683715667",
              "linked": true
            }
          ],
          "clientAccounts": [
            {
              "position": 1,
              "type": "BASE",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "financialInstitutionName": "BNP Parisbas",
              "label": "Aloic Abrim's base account",
              "iban": "BE41561146766410",
              "linked": true
            },
            {
              "position": 2,
              "type": "RESERVE",
              "label": "Aloic Abrim's reserve account",
              "iban": "BE75456473837751",
              "linked": false
            },
            {
              "position": 3,
              "type": "SAVINGS",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "financialInstitutionName": "BNP Parisbas",
              "label": "Aloic Abrim's savings account",
              "iban": "BE45735629549889",
              "linked": true
            },
            {
              "position": 4,
              "type": "VAPH",
              "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
              "financialInstitutionName": "BNP Parisbas",
              "label": "Aloic Abrim's VAPH account",
              "iban": "BE95988969723558"
            }
          ]
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/beneficiaries/[^/]+$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/blocked-users/[^/]+$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/clients/[^/]+/creditors$",
      "response": {
        "status": 200,
        "body": [
          {
            "id": "03f82c89-90a2-4782-aed5-fc4f3f30078a",
            "position": 1,
            "name": "test strucured",
            "address": null,
            "companyNumber": null,
            "iban": "",
            "remittanceInformation": "102933653179",
            "remittanceInformationType": "STRUCTURED",
            "paymentByThirdParties": 0,
            "retainedAmount": 5000,
            "periodicAmountToPay": 100.28,
            "mainSum": null,
            "totalDebt": null,
            "interest": null,
            "costs": null,
            "courtCosts": null,
            "increases": null
          },
          {
            "id": "d969f630-be27-456b-885d-55d03e23a1fe",
            "position": 2,
            "name": "NMBS",
            "address": "adres nmbs",
            "companyNumber": "0203.430.576",
            "iban": "BE91735414567476",
            "remittanceInformation": "debt",
            "remittanceInformationType": "UNSTRUCTURED",
            "paymentByThirdParties": 2000,
            "retainedAmount": 10123,
            "periodicAmountToPay": 162.92,
            "mainSum": 5000,
            "totalDebt": 0.12,
            "interest": 100.1,
            "costs": 12.1,
            "courtCosts": 100,
            "increases": 25
          },
          {
            "id": "0026051c-46f6-4e5f-848e-675fa02a643d",
            "position": 3,
            "name": "NMBS anders",
            "address": null,
            "companyNumber": "0203.430.576",
            "iban": "BE91735414567476",
            "remittanceInformation": "andere schuld",
            "remittanceInformationType": "UNSTRUCTURED",
            "paymentByThirdParties": 0,
            "retainedAmount": 15000,
            "periodicAmountToPay": 300.84,
            "mainSum": 25000,
            "totalDebt": 30000,
            "interest": null,
            "costs": null,
            "courtCosts": 300,
            "increases": 75
          },
          {
            "id": "1ef03f61-a380-4563-9ed6-134a70abd424",
            "position": 4,
            "name": "Proximus",
            "address": "straat 1\n1234 gemeente",
            "companyNumber": "0202.239.951",
            "iban": "BE02663366543140",
            "remittanceInformation": null,
            "remittanceInformationType": null,
            "paymentByThirdParties": 1000,
            "retainedAmount": 15000.21,
            "periodicAmountToPay": 280.8,
            "mainSum": 10000,
            "totalDebt": 10000,
            "interest": 121,
            "costs": 1,
            "courtCosts": 100,
            "increases": 25
          }
        ]
      }
    },
    {
      "endpoint": "^/clients/[^/]+/dossier-info/[^/]+$",
      "response": {
        "status": 200,
        "body": {
          "startDate": "2020-01-01",
          "endDate": "2027-12-31",
          "admissibilityDateSettlement": "2019-12-01",
          "homologationDateSettlement": "2019-12-15",
          "caseIdentifier": "14752",
          "docketNumber": "RN. 125",
          "labourCourt": {
            "id": "ec65f51f-7f61-48ca-805f-86a26cccdcac",
            "name": "Arbeidsrechtbank Antwerpen",
            "department": "afdeling Hasselt"
          },
          "totalDebt": 50000,
          "mainSum": 40000,
          "interest": 4586.54,
          "costs": 1250,
          "courtCosts": 2000,
          "increases": 250,
          "retainedAmount": 45000,
          "settlementType": "PERCENTAGE",
          "settlementAmount": null,
          "settlementPercentage": 15.0,
          "monthlyPaymentsPeriodicity": 3,
          "paymentStartDate": "2021-02-26",
          "paymentEndDate": "2028-02-25",
          "balanceThreshold": 5000
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/general-info$",
      "response": {
        "status": 200,
        "body": {
          "firstName": "Aloic",
          "lastName": "Abrim",
          "address": {
            "street": "Kerkstraat",
            "number": "15",
            "postalCode": "3200",
            "city": "Aarschot"
          },
          "email": "abrim.aloic@gmail.com",
          "birthDate": "1996-07-23",
          "remarks": "Geen opmerkingen",
          "language": "nl"
        }
      }
    },
    {
      "endpoint": "^/default-administrators/[^/]+$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/default-debt-mediators/[^/]+$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/isabel/authorization-codes/[^/]+$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/offices/[^/]+$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/offices/[^/]+/logo$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/password$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/payments",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/profile$",
      "response": {
        "status": 200,
        "body": {
          "id": "1",
          "firstName": "Mocky",
          "lastName": "Balboa",
          "email": "mocky@balboa.com",
          "language": "nl",
          "officeId": "1234",
          "roles": [
            "OFFICE_USER",
            "OFFICE_SUPERVISOR",
            "OFFICE_ADMIN"
          ],
          "invitationPending": false
        }
      }
    },
    {
      "endpoint": "^/settings$",
      "response": {
        "status": 200,
        "body": {}
      }
    },
    {
      "endpoint": "^/users/[^/]+$",
      "response": {
        "status": 204
      }
    }
  ],
  "post": [
    {
      "endpoint": "^/aiars$",
      "response": {
        "status": 200,
        "body": "redirectUri"
      }
    },
    {
      "endpoint": "^/aiar-authorizations$",
      "response": {
        "status": 200,
        "body": {
          "ibans": [
            "BE11233156586548",
            "BE97199999416149",
            "BE31957636366155"
          ]
        }
      }
    },
    {
      "endpoint": "^/bank-accounts/[^/]+/action-requests$",
      "response": {
        "status": 200,
        "body": {
          "id": "1",
          "type": "BASE",
          "logoUrl": "https://ibanity-production-financial-institution-assets.s3.eu-central-1.amazonaws.com/bnp.svg",
          "label": "Aloic Abrim's base account",
          "iban": "BE41561146766410",
          "currentBalance": -458.96,
          "availableBalance": -458.96,
          "currency": "EUR",
          "synchronizedAt": "2024-03-08T05:00:00",
          "status": "ACTIVE",
          "supportPayments": true,
          "clientSettings": {
            "client": {
              "id": "1",
              "firstName": "Aloic",
              "lastName": "Abrim",
              "municipality": "Aarschot",
              "type": "DEBT_MEDIATION",
              "types": [
                "DEBT_MEDIATION",
                "FINANCIAL_MANAGEMENT",
                "BUDGET_GUIDANCE"
              ]
            },
            "type": "BASE",
            "ownerType": "CLIENT",
            "showIncomingTransactions": null,
            "showOutgoingTransactions": null,
            "showBalance": null,
            "balanceShared": true,
            "transactionsShared": true
          }
        }
      }
    },
    {
      "endpoint": "^/bank-accounts/11/transaction-requests$",
      "response": {
        "status": 200,
        "body": {
          "content": [
          ],
          "totalElements": 0,
          "size": 20,
          "number": 0
        }
      }
    },
    {
      "endpoint": "^/bank-accounts/[^/]+/transaction-requests$",
      "response": {
        "status": 200,
        "body": {
          "content": [
            {
              "id": "6aa791d9-392e-4fcf-89d0-d4c0aaca6cd6",
              "executionDate": "2023-12-12",
              "valueDate": "2023-12-12",
              "category": {
                "mainCategoryName": "file",
                "subCategoryName": "dossier-eigen",
                "mainCategoryLabel": "Dossier",
                "subCategoryLabel": "dossier eigen",
                "icon": "https://app-dev.roov.app/assets/icons/folder-closed-solid.svg",
                "creditor": null,
                "type": "DEBIT",
                "debtRepayment": false
              },
              "counterpartReference": "BE91735414567476",
              "counterpartName": "NMBS anders",
              "description": null,
              "remittanceInformation": "andere schuld",
              "remittanceInformationType": "unstructured",
              "amount": -490.39,
              "creditor": null,
              "intraday": true,
              "tags": []
            },
            {
              "id": "3e0e2079-909f-4c69-9a47-c45766273925",
              "executionDate": "2023-12-12",
              "valueDate": "2023-12-11",
              "counterpartReference": null,
              "counterpartName": "Bol",
              "description": null,
              "remittanceInformation": "terugbetaling",
              "remittanceInformationType": "unstructured",
              "amount": 50.0,
              "creditor": null,
              "intraday": false,
              "tags": [
                {
                  "id": "1",
                  "name": "Trein"
                }
              ]
            },
            {
              "id": "05c7b1e3-195e-42a1-b7e2-a9493850c5b4",
              "executionDate": "2023-06-06",
              "valueDate": "2023-06-06",
              "category": {
                "mainCategoryName": "utilities",
                "subCategoryName": "electricity",
                "icon": "https://app-dev.roov.app/assets/icons/plug-circle-bolt-solid.svg",
                "mainCategoryLabel": "Nutsvoorzieningen",
                "subCategoryLabel": "Elektriciteit"
              },
              "counterpartReference": null,
              "counterpartName": "Total Energies",
              "description": null,
              "remittanceInformation": null,
              "remittanceInformationType": "unstructured",
              "amount": -255.0,
              "creditor": null,
              "intraday": false,
              "tags": []
            },
            {
              "id": "6bfc72f4-952e-4f76-856b-d42e5d17a3a4",
              "executionDate": "2023-05-23",
              "valueDate": "2023-05-23",
              "category": {
                "mainCategoryName": "utilities",
                "subCategoryName": "electricity",
                "icon": "https://app-dev.roov.app/assets/icons/plug-circle-bolt-solid.svg",
                "mainCategoryLabel": "Nutsvoorzieningen",
                "subCategoryLabel": "Elektriciteit"
              },
              "counterpartReference": null,
              "counterpartName": "Total Energies",
              "description": null,
              "remittanceInformation": null,
              "remittanceInformationType": "unstructured",
              "amount": -255.0,
              "creditor": null,
              "intraday": false,
              "tags": []
            },
            {
              "id": "9825157d-373f-426d-bf59-34cc99999843",
              "executionDate": "2023-05-08",
              "valueDate": "2023-05-04",
              "category": {
                "mainCategoryName": "file",
                "subCategoryName": "debt-repayment",
                "mainCategoryLabel": "Dossier",
                "subCategoryLabel": "Afbetaling schulden (CSR)",
                "icon": "https://app-dev.roov.app/assets/icons/folder-closed-solid.svg",
                "creditor": null,
                "type": "DEBIT",
                "debtRepayment": true
              },
              "counterpartReference": "BE91735414567476",
              "counterpartName": "NMBS",
              "description": "overschrijving",
              "remittanceInformation": "andere schuld",
              "remittanceInformationType": "unstructured",
              "amount": -25.56,
              "creditor": {
                "id": "250f9686-4593-47b9-87a1-ffe16c5e2d18",
                "position": 5,
                "name": "NMBS"
              },
              "intraday": false,
              "tags": []
            },
            {
              "id": "004d9464-cd3b-4588-97b9-6d6d2be4f2d8",
              "executionDate": "2023-02-05",
              "valueDate": "2023-02-05",
              "category": {
                "mainCategoryName": "income",
                "subCategoryName": "employment",
                "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
                "mainCategoryLabel": "Inkomsten",
                "subCategoryLabel": "Inkomen uit arbeid"
              },
              "counterpartReference": "BE36557631784581",
              "counterpartName": "Group S",
              "description": null,
              "remittanceInformation": "/A/ loon december 2020",
              "remittanceInformationType": "unstructured",
              "amount": 1654.29,
              "creditor": null,
              "intraday": false,
              "tags": []
            },
            {
              "id": "0dbad93c-9418-4093-85a3-78d5b0175d62",
              "executionDate": "2023-01-04",
              "valueDate": "2023-01-04",
              "category": {
                "mainCategoryName": "income",
                "subCategoryName": "employment",
                "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
                "mainCategoryLabel": "Inkomsten",
                "subCategoryLabel": "Inkomen uit arbeid",
                "empty": false
              },
              "counterpartReference": "BE36557631784581",
              "counterpartName": "Group S",
              "description": null,
              "remittanceInformation": "/A/ loon december 2020",
              "remittanceInformationType": "unstructured",
              "amount": 1654.29,
              "creditor": null,
              "intraday": false,
              "tags": []
            },
            {
              "id": "0f65eac2-bda5-4405-ab80-53b8b34dda39",
              "executionDate": "2022-09-12",
              "valueDate": "2022-09-12",
              "category": {
                "mainCategoryName": "income",
                "subCategoryName": "reimbursements-health-insurance",
                "mainCategoryLabel": "Inkomsten",
                "subCategoryLabel": "Terugbetaling ziekenfonds",
                "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
                "creditor": null,
                "type": "CREDIT",
                "debtRepayment": false
              },
              "counterpartReference": null,
              "counterpartName": "Christelijke Mutualiteit",
              "description": "3",
              "remittanceInformation": null,
              "remittanceInformationType": null,
              "amount": 56.0,
              "creditor": null,
              "intraday": false,
              "tags": []
            },
            {
              "id": "04315bf3-4174-44ca-b8f8-9a85f9e33c9f",
              "executionDate": "2022-09-09",
              "valueDate": "2022-09-09",
              "category": {
                "mainCategoryName": "income",
                "subCategoryName": "child-support-children",
                "mainCategoryLabel": "Inkomsten",
                "subCategoryLabel": "Kinderbijslag (kinderen)",
                "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
                "creditor": null,
                "type": "CREDIT",
                "debtRepayment": false
              },
              "counterpartReference": null,
              "counterpartName": "Famiris",
              "description": "4",
              "remittanceInformation": null,
              "remittanceInformationType": null,
              "amount": 176.0,
              "creditor": null,
              "intraday": false,
              "tags": []
            },
            {
              "id": "6fe50f69-5374-4631-9139-08fceb23e39b",
              "executionDate": "2022-07-10",
              "valueDate": "2022-07-10",
              "category": {
                "mainCategoryName": "income",
                "subCategoryName": "income-other",
                "mainCategoryLabel": "Inkomsten",
                "subCategoryLabel": "Inkomsten (andere)",
                "icon": "https://app-dev.roov.app/assets/icons/sack-dollar-solid.svg",
                "creditor": null,
                "type": "CREDIT",
                "debtRepayment": false
              },
              "counterpartReference": "BE71096123456769",
              "counterpartName": "Vanessa",
              "description": "description income",
              "remittanceInformation": "test 1",
              "remittanceInformationType": "unstructured",
              "amount": 100.0,
              "creditor": null,
              "intraday": false,
              "tags": []
            }
          ],
          "totalElements": 10,
          "size": 20,
          "number": 0
        }
      }
    },
    {
      "endpoint": "^/bank-accounts/[^/]+/transaction-reports/[^/]+$",
      "response": {
        "status": 200,
        "body": []
      }
    },
    {
      "endpoint": "^/clients$",
      "response": {
        "status": 200,
        "body": {
          "id": "1"
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/batch/payments",
      "response": {
        "status": 200,
        "body": {
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/beneficiaries$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/clients/[^/]+/document-requests$",
      "response": {
        "status": 200,
        "body": {
          "content": [
            {
              "id": "4977ea5d-0ecb-428c-bb37-a0744f516fd1",
              "name": "betaling",
              "extension": "pdf",
              "createdAt": "2024-06-12T20:07:19.129",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": {
                "id": "064c31bf-c0a7-4893-8c98-0e9ee385a0f6",
                "firstName": "Jack",
                "lastName": "De Ripper"
              },
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "5f1000be-abee-4773-bd1b-419a4da8b23d",
              "name": "Rekeninguittreksel 2023-01-01 - 2023-12-31 (BE51954422242762)",
              "extension": "pdf",
              "createdAt": "2024-06-12T20:03:33.422",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "YEARLY_OVERSIGHT_REPORT",
              "owner": {
                "id": "064c31bf-c0a7-4893-8c98-0e9ee385a0f6",
                "firstName": "Jack",
                "lastName": "De Ripper"
              },
              "status": "DONE",
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "a180c635-4b05-44cd-849c-2b10031fcb1d",
              "name": "Jaarverslag schuldbemiddeling (BE51954422242762)",
              "extension": "docx",
              "createdAt": "2024-05-24T06:36:58.257",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "YEARLY_DEBT_REPORT",
              "owner": {
                "id": "064c31bf-c0a7-4893-8c98-0e9ee385a0f6",
                "firstName": "Jack",
                "lastName": "De Ripper"
              },
              "status": "DONE",
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "2c56e398-835a-4323-9e8f-c01ee56a6ff8",
              "name": "afbeelding",
              "extension": "jpg",
              "createdAt": "2023-04-14T13:45:03.528",
              "hidden": false,
              "ownDocument": false,
              "shared": false,
              "type": "IMAGE",
              "owner": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim"
              },
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "bc0de5af-78e3-4971-95b2-b1c30b3bc522",
              "name": "Akkoordverklaring",
              "extension": "pdf",
              "createdAt": "2023-03-21T09:54:52.024",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-hidden",
              "name": "Hidden",
              "extension": "pdf",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": true,
              "ownDocument": false,
              "shared": false,
              "type": "DOCUMENT",
              "owner": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim"
              },
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-bmp",
              "name": "Windows OS/2 Bitmap Graphics",
              "extension": "bmp",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-bz",
              "name": "BZip archive",
              "extension": "bz",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-bz2",
              "name": "BZip2 archive",
              "extension": "bz2",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-csv",
              "name": "Comma-separated values",
              "extension": "csv",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-doc",
              "name": "Microsoft Word",
              "extension": "doc",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-docx",
              "name": "Microsoft Word (OpenXML)",
              "extension": "docx",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-gif",
              "name": "Graphics Interchange Format",
              "extension": "gif",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-gz",
              "name": "GZip Compressed Archive",
              "extension": "gz",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-jpeg",
              "name": "JPEG image",
              "extension": "jpeg",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-jpg",
              "name": "JPG image",
              "extension": "jpg",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-odp",
              "name": "OpenDocument presentation document",
              "extension": "odp",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-ods",
              "name": "OpenDocument spreadsheet document",
              "extension": "ods",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-odt",
              "name": "OpenDocument text document",
              "extension": "odt",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-pdf",
              "name": "Adobe Portable Document Format",
              "extension": "pdf",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-png",
              "name": "Portable Network Graphics",
              "extension": "png",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-ppt",
              "name": "Microsoft PowerPoint",
              "extension": "ppt",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-pptx",
              "name": "Microsoft PowerPoint (OpenXML)",
              "extension": "pptx",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-rar",
              "name": "RAR archive",
              "extension": "rar",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-rtf",
              "name": "Rich Text Format",
              "extension": "rtf",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-svg",
              "name": "Scalable Vector Graphics",
              "extension": "svg",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-tar",
              "name": "Tape Archive",
              "extension": "tar",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-tif",
              "name": "Tagged Image File",
              "extension": "tif",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-tiff",
              "name": "Tagged Image File Format",
              "extension": "tiff",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-txt",
              "name": "Text",
              "extension": "txt",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-xls",
              "name": "Microsoft Excel",
              "extension": "xls",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-xlsx",
              "name": "Microsoft Excel (OpenXML)",
              "extension": "xlsx",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-zip",
              "name": "ZIP archive",
              "extension": "zip",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-7z",
              "name": "7-zip archive",
              "extension": "7z",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            }
          ],
          "totalElements": 34,
          "size": 50,
          "number": 0
        }
      }
    },
    {
      "endpoint": "^/clients/[^/]+/process-notifications-requests$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/clients/[^/]+/referral-code-mail-requests$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/clients/[^/]+/transaction-tags$",
      "response": {
        "status": 200,
        "body": {
          "id": "999",
          "name": "nieuw"
        }
      }
    },
    {
      "endpoint": "^/document-requests$",
      "response": {
        "status": 200,
        "body": {
          "content": [
            {
              "id": "4977ea5d-0ecb-428c-bb37-a0744f516fd1",
              "name": "betaling",
              "extension": "pdf",
              "createdAt": "2024-06-12T20:07:19.129",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": {
                "id": "064c31bf-c0a7-4893-8c98-0e9ee385a0f6",
                "firstName": "Jack",
                "lastName": "De Ripper"
              },
              "status": null
            },
            {
              "id": "5f1000be-abee-4773-bd1b-419a4da8b23d",
              "name": "Rekeninguittreksel 2023-01-01 - 2023-12-31 (BE51954422242762)",
              "extension": "pdf",
              "createdAt": "2024-06-12T20:03:33.422",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "YEARLY_OVERSIGHT_REPORT",
              "owner": {
                "id": "064c31bf-c0a7-4893-8c98-0e9ee385a0f6",
                "firstName": "Jack",
                "lastName": "De Ripper"
              },
              "status": "DONE"
            },
            {
              "id": "a180c635-4b05-44cd-849c-2b10031fcb1d",
              "name": "Jaarverslag schuldbemiddeling (BE51954422242762)",
              "extension": "docx",
              "createdAt": "2024-05-24T06:36:58.257",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "YEARLY_DEBT_REPORT",
              "owner": {
                "id": "064c31bf-c0a7-4893-8c98-0e9ee385a0f6",
                "firstName": "Jack",
                "lastName": "De Ripper"
              },
              "status": "DONE",
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "2c56e398-835a-4323-9e8f-c01ee56a6ff8",
              "name": "afbeelding",
              "extension": "jpg",
              "createdAt": "2023-04-14T13:45:03.528",
              "hidden": false,
              "ownDocument": false,
              "shared": false,
              "type": "IMAGE",
              "owner": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim"
              },
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "bc0de5af-78e3-4971-95b2-b1c30b3bc522",
              "name": "Akkoordverklaring",
              "extension": "pdf",
              "createdAt": "2023-03-21T09:54:52.024",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-hidden",
              "name": "Hidden",
              "extension": "pdf",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": true,
              "ownDocument": false,
              "shared": false,
              "type": "DOCUMENT",
              "owner": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim"
              },
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-bmp",
              "name": "Windows OS/2 Bitmap Graphics",
              "extension": "bmp",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-bz",
              "name": "BZip archive",
              "extension": "bz",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-bz2",
              "name": "BZip2 archive",
              "extension": "bz2",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-csv",
              "name": "Comma-separated values",
              "extension": "csv",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-doc",
              "name": "Microsoft Word",
              "extension": "doc",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-docx",
              "name": "Microsoft Word (OpenXML)",
              "extension": "docx",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-gif",
              "name": "Graphics Interchange Format",
              "extension": "gif",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-gz",
              "name": "GZip Compressed Archive",
              "extension": "gz",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-jpeg",
              "name": "JPEG image",
              "extension": "jpeg",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-jpg",
              "name": "JPG image",
              "extension": "jpg",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-odp",
              "name": "OpenDocument presentation document",
              "extension": "odp",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-ods",
              "name": "OpenDocument spreadsheet document",
              "extension": "ods",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-odt",
              "name": "OpenDocument text document",
              "extension": "odt",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-pdf",
              "name": "Adobe Portable Document Format",
              "extension": "pdf",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-png",
              "name": "Portable Network Graphics",
              "extension": "png",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-ppt",
              "name": "Microsoft PowerPoint",
              "extension": "ppt",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-pptx",
              "name": "Microsoft PowerPoint (OpenXML)",
              "extension": "pptx",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-rar",
              "name": "RAR archive",
              "extension": "rar",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-rtf",
              "name": "Rich Text Format",
              "extension": "rtf",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-svg",
              "name": "Scalable Vector Graphics",
              "extension": "svg",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-tar",
              "name": "Tape Archive",
              "extension": "tar",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-tif",
              "name": "Tagged Image File",
              "extension": "tif",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-tiff",
              "name": "Tagged Image File Format",
              "extension": "tiff",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "IMAGE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-txt",
              "name": "Text",
              "extension": "txt",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-xls",
              "name": "Microsoft Excel",
              "extension": "xls",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-xlsx",
              "name": "Microsoft Excel (OpenXML)",
              "extension": "xlsx",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "DOCUMENT",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-zip",
              "name": "ZIP archive",
              "extension": "zip",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            },
            {
              "id": "doc-7z",
              "name": "7-zip archive",
              "extension": "7z",
              "createdAt": "2024-07-03T15:38:24.123",
              "hidden": false,
              "ownDocument": true,
              "shared": false,
              "type": "ARCHIVE",
              "owner": null,
              "status": null,
              "client": {
                "id": "1",
                "firstName": "Aloic",
                "lastName": "Abrim",
                "municipality": "Aarschot",
                "type": "DEBT_MEDIATION",
                "types": [
                  "DEBT_MEDIATION",
                  "FINANCIAL_MANAGEMENT",
                  "BUDGET_GUIDANCE"
                ]
              }
            }
          ],
          "totalElements": 34,
          "size": 50,
          "number": 0
        }
      }
    },
    {
      "endpoint": "^/courts/[^/]+/active-debt-dossiers-report-requests",
      "response": {
        "status": 200
      }
    },
    {
      "endpoint": "^/documents/[^/]+/predict-client-requests",
      "response": {
        "status": 200,
        "body": {
          "predictedClient": {
            "id": "1",
            "firstName": "Aloic",
            "lastName": "Abrim",
            "municipality": "Aarschot",
            "type": "DEBT_MEDIATION",
            "types": [
              "DEBT_MEDIATION",
              "FINANCIAL_MANAGEMENT",
              "BUDGET_GUIDANCE"
            ]
          }
        }
      }
    },
    {
      "endpoint": "^/export-creditors-requests$",
      "response": {
        "status": 200,
        "body": [
          {
            "position": 1,
            "name": "Fiducré",
            "address": "Marnixlaan 24 1000 Brussel",
            "iban": "BE88652040852341",
            "remittanceInformation": "104651553087",
            "remittanceInformationType": "STRUCTURED",
            "creditorAmounts": {
              "capital": 2014.21,
              "interest": 153.4,
              "negligence": 56.61,
              "penalty": 201.42,
              "costs": 0.0
            },
            "mediatorAmounts": {
              "capital": 2004.21,
              "interest": 153.4,
              "negligence": 56.61,
              "penalty": 0.0,
              "costs": 0.0
            }
          },
          {
            "position": 2,
            "name": "Mega",
            "address": "Vaartstraat 167 3000 Leuven",
            "iban": "BE96363120586905",
            "remittanceInformation": "ME955487",
            "remittanceInformationType": "UNSTRUCTURED",
            "creditorAmounts": {
              "capital": 424.68,
              "interest": 0.0,
              "negligence": 0.0,
              "penalty": 0.0,
              "costs": 0.0
            },
            "mediatorAmounts": {
              "capital": 424.68,
              "interest": 0.0,
              "negligence": 0.0,
              "penalty": 0.0,
              "costs": 0.0
            }
          },
          {
            "position": 3,
            "name": "FOD Financiën",
            "address": "Koning Albert II laan 33 1 1030 Brussel",
            "iban": "BE42679200000054",
            "remittanceInformation": "CR23/62.10.08.131-27",
            "remittanceInformationType": "UNSTRUCTURED",
            "creditorAmounts": {
              "capital": 6296.75,
              "interest": 0.0,
              "negligence": 0.0,
              "penalty": 0.0,
              "costs": 0.0
            },
            "mediatorAmounts": {
              "capital": 6296.75,
              "interest": 0.0,
              "negligence": 0.0,
              "penalty": 15.0,
              "costs": 0.0
            }
          }
        ]
      }
    },
    {
      "endpoint": "^/office-transaction-categories$",
      "response": {
        "status": 200,
        "body": [
          {
            "mainCategoryName": "other",
            "subCategoryName": "nieuw",
            "mainCategoryLabel": "Andere",
            "subCategoryLabel": "nieuw",
            "icon": "https://app-dev.roov.app/assets/icons/star-solid.svg",
            "creditor": null,
            "type": "CREDIT",
            "debtRepayment": false
          }
        ]
      }
    },
    {
      "endpoint": "^/payment-initiations$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/process-documents-requests$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/process-notifications-requests$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/users$",
      "response": {
        "status": 204
      }
    }
  ],
  "patch": [
    {
      "endpoint": "^/clients/[^/]+/documents/[^/]+$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/documents/[^/]+$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/notifications/[^/]+$",
      "response": {
        "status": 204
      }
    }
  ],
  "delete": [
    {
      "endpoint": "^/blocked-users/[^/]+$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/clients/[^/]+/beneficiaries/[^/]+$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/clients/[^/]+/documents/[^/]+$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/documents/[^/]+$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/invited-users/[^/]+$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/offices/[^/]+/logo$",
      "response": {
        "status": 204
      }
    },
    {
      "endpoint": "^/payments/[^/]+$",
      "response": {
        "status": 204
      }
    }
  ]
}
